import React, { ChangeEvent, Fragment, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory, useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "hooks/redux";

import { StatusCode } from "api/protocols";

import { convertTime, displayCurrency } from "helpers/Helpers";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import { dequeue, enqueue, IUIActions, showError } from "redux/actions/ui";
import { ClientPortalNavigation } from "../ClientPortalNavigation";

import Panel from "components/panel/Panel";
import Sheet from "components/sheet/Sheet";
import Spin from "components/spin/spin";
import { ButtonNew as Button } from "components/buttonNew";
import { IFacility } from "redux/reducers/models/facility";
import ReactDOM from "react-dom";
import { clientPortalUpdate } from "redux/actions/clientPortal";
import CustomDropdown from "components/customDropdown/CustomDropdown";
import CustomDropdownOption from "components/customDropdown/CustomDropdownOption";
import { GetClient } from "api/rpc/2024-04/customer/client";
import { GetClientGuest } from "api/rpc/2024-04/guest/client";
import { GetFacility } from "api/rpc/2024-04/customer/facility";
import { GetFacilityGuest } from "api/rpc/2024-04/guest/facility";
import { sortFacilities } from "redux/reducers/clientPortal";
import "./clientPortalFoodOrdering.scss";
import classNames from "classnames";
import Input from "components/form/input";
import { ICartActions } from "redux/actions/customer/cart";
import { ICartState } from "redux/reducers/customer/cart";
import { ICart, ICartLineItem } from "redux/reducers/customer/models/cart";
import TextField from "components/form/textField/TextField";
import Checkbox from "components/form/checkbox/Checkbox";
// import { IModifierGroup } from "api/rpc/facilityAdmin/modifierGroups";
import { IVariant } from "redux/reducers/models/product";
import Popup from "components/popup/Popup";
import { UserActive, UserLogout } from "api/rpc";
import { GetFoodOrderingCategories, GetFoodOrderingSettings } from "api/rpc/2024-04/guest/foodOrdering";
import { GetProducts, IModifierGroup } from "api/rpc/2024-04/guest/product";
import {
  faPlus,
  faMinus,
  faTimes,
  faEllipsisVertical,
  faBurgerSoda,
  faSpinnerThird,
  faTrashCan,
  faUtensilsSlash,
  faArrowLeft,
  faClock,
  faExclamationCircle,
} from "@fortawesome/pro-regular-svg-icons";
import { LocaleCurrency } from "helpers/Locale";
import Icon from "components/icon/Icon";
import Callout from "components/callout/Callout";
import { useTranslation } from "react-i18next";
import FoodOrderingProductCard from "components/foodOrdering/FoodOrderingProductCard";
import AddRemoveButton from "components/foodOrdering/AddRemoveButton";
import useOnclickOutside from "hooks/useOnclickOutside/useOnclickOutside";
import { IProduct } from "pages/guest/models/product";
import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { Badge } from "components/badge/Badge";

interface IParams {
  clientShortName: string;
  facilityShortName: string;
}

interface IModifierState {
  sheetOpen: boolean;
  allModifierGroups: IModifierGroup[];
  selectedModifierVariants: { [key: string]: IVariant[] };
  quantity: number;
  productNote: string;
  modifiedProduct: any;
  modifiedVariant: INewIVariant;
  line_item: ICartLineItem;
}

interface IFilterState {
  facilitySearchQuery: string;
  searchedFacilities: Array<IFacility>;
  searchQuery: string;
  showSearch: boolean;
  cartQuantity: number;

  adminUserLoggedIn: boolean;

  cartNote: string;
  viewCart: boolean;

  showCartOption: boolean;
  clearCart: boolean;
  allow_off_course_orders: boolean;
  show_product_images: boolean;
  pickup_type: string;
  open_time: string;
  close_time: string;
  enabled: boolean;

  show_hours: boolean;
  view_menu: boolean;
}

interface IEditLineItemState {
  openEditLineItem: boolean;
  product: any;
  variant: INewIVariant;
  line_item: ICartLineItem;
  quantity: number;
  note: string;
  allModifierGroups: IModifierGroup[];
  selectedModifierVariants: { [key: string]: IVariant[] };
}

interface IProductDetailsState {
  openProductDetails: boolean;
  product: any;
  quantityToAdd: number;
  variant: INewIVariant;
  line_item: ICartLineItem;
  note: string;
}

export interface INewIVariant extends IVariant {
  categoryName: string;
}

export interface IFoodOrderingProduct {
  id: number;
  title: string;
  price: number;
  description: string;
  category?: string;
  variant_id?: number;
  modifiers?: IFoodOrderingProduct[];
  source?: string;
  variants?: INewIVariant[];
  default_image: any;
}

interface IFoodOrderingMenuProps {
  cartStore: ICartState;
  cartActions: ICartActions;
  uiActions: IUIActions;
}

interface IFoodOrderingMenuState {
  foodOrderingCategories: any[];
  payOnlineEnabled: boolean;
}

interface IModifierGroupsState {
  [key: string]: ICartLineItem[];
}

export interface IFoodOrderingCategory {
  products: IFoodOrderingProduct[];
  id: number;
  facility_id: number;
  title: string;
  position: number;
}

export function getFoodOrderingCartTokenName(facilityShortName: string) {
  return `${facilityShortName}_food_ordering_customer_cart_token`;
}

export function getFoodOrderingCartToken(facilityShortName: string) {
  return localStorage.getItem(getFoodOrderingCartTokenName(facilityShortName));
}

type OperatingHour = {
  day_of_week_number: number; // 1 = Monday, 7 = Sunday
  open_time: string;
  close_time: string;
  closed: boolean;
  day_of_week: string;
};

type DayHoursResult = {
  todayHours?: OperatingHour;
  nextDayHours?: OperatingHour;
  nextOpenDay?: OperatingHour;
};

interface IFoodOrderingClosedState {
  closed: boolean;
  operating_hours: IOperatingHours[];
  today: OperatingHour;
  tomorrow: OperatingHour;
  nextOpenDay: OperatingHour;
}

interface IOperatingHours {
  id?: number;
  facility_id?: number;
  day_of_week_number?: number;
  day_of_week?: string;
  open_time?: string;
  close_time?: string;
  closed?: boolean;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

export default function FoodOrderingMenu(props: IFoodOrderingMenuProps) {
  const { clientShortName, facilityShortName } = useParams<IParams>();
  const { cartStore, cartActions, uiActions } = props;
  const { clientPortalStore } = useAppSelector(store => store);
  const MAX_LINE_ITEM_QUANTITY = 5;
  const elementRef = useRef([]);
  const searchRef = useRef(null);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [tabSelected, setTabSelected] = useState<number>(0);
  const [updatingQuantity, setUpdatingQuantity] = useState<number>(null);
  const windowSize = useWindowSize();
  const { t } = useTranslation();

  const [foodOrderingClosedState, setFoodOrderingClosedState] = useState<IFoodOrderingClosedState>({
    closed: false,
    operating_hours: [],
    today: null,
    tomorrow: null,
    nextOpenDay: null,
  });

  const [filterState, setFilterState] = useState<IFilterState>({
    facilitySearchQuery: "",
    searchedFacilities: [],
    searchQuery: "",
    showSearch: false,
    cartQuantity: 0,
    // modifiedProduct: null,
    // modifiedVariant: null,
    adminUserLoggedIn: false,
    cartNote: "",
    viewCart: false,
    showCartOption: false,
    clearCart: false,
    allow_off_course_orders: false,
    show_product_images: false,
    pickup_type: "dine_in",
    open_time: "",
    close_time: "",
    enabled: false,
    show_hours: false,
    view_menu: false,
  });

  const [foodOrderingMenuState, setFoodOrderingMenuState] = useState<IFoodOrderingMenuState>({
    foodOrderingCategories: [],
    payOnlineEnabled: false,
  });

  const [editLineItemState, setEditLineItemState] = useState<IEditLineItemState>({
    product: null,
    variant: null,
    openEditLineItem: false,
    line_item: null,
    quantity: null,
    note: "",
    allModifierGroups: [],
    selectedModifierVariants: null,
  });

  const [productDetailsState, setProductDetailsState] = useState<IProductDetailsState>({
    openProductDetails: false,
    product: null,
    variant: null,
    quantityToAdd: null,
    line_item: null,
    note: "",
  });

  const [modifierState, setModifierState] = useState<IModifierState>({
    sheetOpen: false,
    allModifierGroups: [],
    selectedModifierVariants: null,
    quantity: 1,
    productNote: "",
    modifiedProduct: null,
    modifiedVariant: null,
    line_item: null,
  });

  const [modifierGroups, setModifierGroups] = useState<IModifierGroupsState>({});

  useEffect(() => {
    if (clientPortalStore.client === null) {
      void getClient();
    }

    const options = {
      rootMarginTop: "100px",
      threshold: 0.75,
    };
    const observer = new IntersectionObserver(intersectionCallback, options);

    foodOrderingMenuState?.foodOrderingCategories?.map((category: any, index: number) => {
      const ref = elementRef.current[index];
      if (ref) {
        observer.observe(ref as Element);
      }
    });

    // void loadMenuPage();
  }, [foodOrderingMenuState?.foodOrderingCategories]);

  useEffect(() => {
    let quantity = 0;

    cartStore?.cart?.line_items
      ?.filter((line_item: ICartLineItem) => line_item.parent_id === null)
      ?.map((lineItem: ICartLineItem) => {
        quantity = lineItem.quantity + quantity;
      });

    setFilterState(prevState => ({ ...prevState, cartQuantity: quantity }));
  }, [cartStore?.cart?.line_items]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    let timeoutId: NodeJS.Timeout = null;

    if (clientPortalStore?.client) {
      timeoutId = global.setTimeout(() => {
        if (clientPortalStore?.selectedFacility) {
          //   void loadFoodOrderingSettings();
          void loadFoodOrderingProducts();
          void loadCart();
        }
      }, 500);
    }

    return () => {
      source.cancel("Cancelled");
      clearTimeout(timeoutId);
    };
  }, [clientPortalStore?.selectedFacility, clientPortalStore?.client]);

  useEffect(() => {
    if (clientPortalStore?.selectedFacility) {
      window.sessionStorage.setItem("facilityShortName", clientPortalStore?.selectedFacility.short_name);
    }
  }, [clientPortalStore?.selectedFacility]);

  useEffect(() => {
    void groupModifiers();
  }, [cartStore?.cart?.line_items]);

  useEffect(() => {
    const type = window.sessionStorage.getItem("pickupType");

    if (type !== null) {
      setFilterState(prevState => ({ ...prevState, pickup_type: type }));
    }
  }, []);

  useEffect(() => {
    if (!filterState?.allow_off_course_orders) {
      setFilterState(prevState => ({ ...prevState, pickup_type: "pickup" }));
      window.sessionStorage.setItem("pickupType", "pickup");
    }
  }, [filterState?.allow_off_course_orders]);

  useEffect(() => {
    void loadFoodOrderingSettings();
  }, [clientPortalStore?.selectedFacility, clientPortalStore?.client]);

  const isOkDisabled = useMemo(() => {
    if (!modifierState?.allModifierGroups?.length) {
      return false;
    }

    return modifierState.allModifierGroups.some(modifierGroup => {
      if (!modifierGroup.required) {
        return false;
      }

      const selectedVariants = modifierState?.selectedModifierVariants[modifierGroup?.id.toString()] || [];
      return selectedVariants.length === 0;
    });
  }, [modifierState?.allModifierGroups, modifierState?.selectedModifierVariants]);

  function getTodayAndNextDayHours(operatingHours: OperatingHour[]): DayHoursResult {
    const today = new Date();
    const todayNum = today.getDay() === 0 ? 7 : today.getDay(); // convert Sunday=0 to 7
    const nextDayNum = todayNum === 7 ? 1 : todayNum + 1;

    const todayHours = operatingHours.find(h => h.day_of_week_number === todayNum);
    const nextDayHours = operatingHours.find(h => h.day_of_week_number === nextDayNum);

    // 🔎 Find the next day that is NOT closed
    let nextOpenDay: OperatingHour | undefined;
    for (let i = 1; i <= 7; i++) {
      const dayNum = ((todayNum + i - 1) % 7) + 1; // cycles through 1-7
      const candidate = operatingHours.find(h => h.day_of_week_number === dayNum);

      if (candidate && !candidate.closed) {
        nextOpenDay = candidate;
        break;
      }
    }

    return { todayHours, nextDayHours, nextOpenDay };
  }

  async function loadFoodOrderingSettings() {
    if (clientPortalStore?.selectedFacility) {
      const params = {
        facility_id: clientPortalStore?.selectedFacility?.id,
      };

      const foodOrderingSettingsRes = await GetFoodOrderingSettings(params, true);

      if (foodOrderingSettingsRes?.status !== StatusCode.OK) {
        dispatch(showError(foodOrderingSettingsRes.message ?? "Error getting food ordering settings"));
        return;
      }

      if (foodOrderingSettingsRes.data?.closed) {
        const { todayHours, nextDayHours, nextOpenDay } = getTodayAndNextDayHours(
          foodOrderingSettingsRes?.data?.operating_hours as OperatingHour[],
        );

        setFoodOrderingClosedState(prevState => ({
          ...prevState,
          closed: foodOrderingSettingsRes?.data?.closed,
          operating_hours: foodOrderingSettingsRes?.data?.operating_hours,
          today: todayHours,
          tomorrow: nextDayHours,
          nextOpenDay: nextOpenDay,
        }));

        setFilterState(prevState => ({
          ...prevState,
          enabled: foodOrderingSettingsRes.data?.enabled,

          // pickup_type: foodOrderingSettingsRes.data?.allow_off_course_orders ? window.sessionStorage.getItem("pickupType") : "dine_in" : "pickup",
        }));
        return;
      }

      setFilterState(prevState => ({
        ...prevState,
        allow_off_course_orders: foodOrderingSettingsRes.data?.allow_off_course_orders,
        show_product_images: foodOrderingSettingsRes.data?.show_product_images,
        open_time: foodOrderingSettingsRes.data?.open_time,
        close_time: foodOrderingSettingsRes.data?.close_time,
        enabled: foodOrderingSettingsRes.data?.enabled,

        // pickup_type: foodOrderingSettingsRes.data?.allow_off_course_orders ? window.sessionStorage.getItem("pickupType") : "dine_in" : "pickup",
      }));

      // window.sessionStorage.setItem("pickupType", foodOrderingSettingsRes.data?.allow_off_course_orders ? "dine_in" : "pickup");
    }
  }

  async function loadCart() {
    let cart: ICart = undefined;

    if (getFoodOrderingCartToken(clientPortalStore?.selectedFacility?.short_name)) {
      try {
        const getCartPromise: Promise<ICart> = cartStore?.isLoaded
          ? Promise.resolve(cartStore?.cart)
          : (cartActions.loadCart(
              {
                facility_id: clientPortalStore?.selectedFacility?.id,
                tokenName: getFoodOrderingCartTokenName(clientPortalStore?.selectedFacility?.short_name),
                token: getFoodOrderingCartToken(clientPortalStore?.selectedFacility?.short_name),
              },
              true,
            ) as unknown as Promise<ICart>);

        cart = await getCartPromise;
      } catch {
        uiActions.showError(t("Error getting cart"));
        uiActions.dequeue();
        return;
      }
    }

    if (cart?.status === "complete") {
      cartActions.cartClear({
        tokenName: getFoodOrderingCartTokenName(clientPortalStore?.selectedFacility?.short_name),
      });
      return;
    }

    if (cartStore.cart === null && cartStore.isLoaded === false && cart !== undefined) {
      dispatch({
        type: "cart.update",
        payload: {
          isLoaded: true,
          cart: cart,
        },
      });
    }
  }

  function groupModifiers() {
    const groups = cartStore?.cart?.line_items?.reduce(
      (prevModifierGroups: { [key: string]: Array<ICartLineItem> }, lineItem: any) => {
        if (lineItem.parent_id !== null) {
          return {
            ...prevModifierGroups,
            [lineItem.parent_id]: [...(prevModifierGroups[lineItem.parent_id] || []), lineItem],
          };
        } else {
          return prevModifierGroups;
        }
      },
      {},
    );

    setModifierGroups(groups);
  }

  async function loadFoodOrderingProducts() {
    const params = {
      facility_id: clientPortalStore?.selectedFacility.id,
      products: true,
    };

    const foodOrderingCategoriesRes = await GetFoodOrderingCategories(params, true);
    if (foodOrderingCategoriesRes?.status !== StatusCode.OK) {
      dispatch(showError(t("Error getting food ordering categories")));
      return;
    }

    const foodOrderingCategoryNames: any[] = [];

    foodOrderingCategoriesRes?.data?.map((category: any) => {
      category?.products?.map((product: any) => {
        product.categoryName = category.title;
        if (product.variants.length > 1) {
          {
            product?.variants?.map((variant: any) => {
              variant.categoryName = category.title;
            });
          }
        } else {
          product.variants[0].categoryName = category.title;
        }
      });

      const categoryKeyValue = [category.id, category.title];
      foodOrderingCategoryNames.push(categoryKeyValue);
    });

    setFoodOrderingMenuState(prevState => ({ ...prevState, foodOrderingCategories: foodOrderingCategoriesRes.data }));
  }

  function handleTabChange(selectedTabIndex: number) {
    const ref = elementRef.current[selectedTabIndex];

    ref?.scrollIntoView({ block: "start", behavior: "smooth" });
    setTabSelected(selectedTabIndex);
  }

  const intersectionCallback = (entries: any[]) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const elem = entry.target;
        const tab = String(elem.id).slice(4);
        setTabSelected(Number(tab));
      }
    });
  };

  async function getClient() {
    let currentActiveUser = !!clientPortalStore?.user;
    let selectedClient = clientPortalStore?.client;
    let selectedFacility = clientPortalStore?.selectedFacility;

    dispatch(enqueue());

    const activeUserRes = await UserActive(false);
    if (activeUserRes?.status === StatusCode.OK) {
      currentActiveUser = true;
    }

    if (Number(activeUserRes?.data?.user_type) === 2 || Number(activeUserRes?.data?.user_type) === 3) {
      setFilterState(prevState => ({ ...prevState, adminUserLoggedIn: true }));
      dispatch(dequeue());
      return;
    }

    if (
      !clientPortalStore?.client ||
      !clientPortalStore?.selectedFacility ||
      (clientPortalStore?.selectedFacility?.favourite === undefined && currentActiveUser)
    ) {
      let clientRes;
      let facilityRes;
      if (currentActiveUser) {
        currentActiveUser = true;
        clientRes = await GetClient({ short_name: clientShortName }, true);
      } else {
        clientRes = await GetClientGuest({ short_name: clientShortName }, true);
      }

      if (clientRes.status !== StatusCode.OK || clientRes?.data?.length === 0) {
        dispatch(dequeue());
        dispatch(showError(t("Error loading client")));
        return;
      }
      selectedClient = clientRes?.data[0];
      if (currentActiveUser) {
        facilityRes = await GetFacility({ client_id: selectedClient?.id, order_by: "long_name" }, false);
      } else {
        facilityRes = await GetFacilityGuest({ client_id: selectedClient?.id, order_by: "long_name" }, false);
      }

      if (facilityRes?.status !== StatusCode.OK || facilityRes?.data?.length === 0) {
        dispatch(dequeue());
        dispatch(showError(t("Error loading facilities")));
        return;
      }

      //Sort by Favourite facilities
      const sortedFacilities = sortFacilities(facilityRes?.data);

      selectedFacility = selectedFacility
        ? sortedFacilities?.find(facility => facility?.id === selectedFacility?.id)
        : facilityShortName
        ? sortedFacilities?.find(facility => facility?.short_name === facilityShortName)
        : sortedFacilities[0];
      if (!selectedFacility && sortedFacilities?.length > 0) {
        selectedFacility = sortedFacilities[0];
      }
      selectedClient = { ...selectedClient, facilities: sortedFacilities };

      //   if(currentActiveUser) {
      //     cartActions.putCart()
      //   }

      dispatch(
        clientPortalUpdate({
          client: selectedClient,
          selectedFacility,
          // waitlist_reference_id: waitlist_reference_id ?? null,
        }),
      );
    }

    ReactDOM.unstable_batchedUpdates(() => {
      dispatch(dequeue());
      dispatch(
        clientPortalUpdate({
          user: currentActiveUser ? activeUserRes?.data : undefined,
        }),
      );
    });
    //   await checkLoginRequired(selectedFacility, currentActiveUser);
  }

  const facilities = useMemo(() => {
    if (filterState?.facilitySearchQuery) {
      return clientPortalStore?.client?.facilities?.filter(
        facility =>
          facility?.long_name.toLowerCase().includes(filterState?.facilitySearchQuery?.toLowerCase()) ||
          facility?.city.toLowerCase().includes(filterState?.facilitySearchQuery?.toLowerCase()),
      );
    } else if (clientPortalStore?.client?.facilities) {
      return clientPortalStore?.client?.facilities;
    } else {
      return [];
    }
  }, [filterState?.searchedFacilities, clientPortalStore?.client?.facilities, filterState.facilitySearchQuery]);

  const selectedFacilityElement = (
    <div className={"food-ordering-facility-container"}>
      {clientPortalStore?.client?.facilities?.length > 1 && clientPortalStore?.selectedFacility?.logo_source && (
        <div>
          <img className="food-ordering-home-course-logo" src={clientPortalStore?.selectedFacility?.logo_source} />
        </div>
      )}
      <div>
        <div className="food-ordering-home-course-name">{clientPortalStore?.selectedFacility?.long_name}</div>
        {clientPortalStore?.selectedFacility && (
          <div className="food-ordering-course-secondary-information">
            {`${clientPortalStore?.selectedFacility?.address_line_1}, ${clientPortalStore?.selectedFacility?.city}, ${clientPortalStore?.selectedFacility?.province_name}, ${clientPortalStore?.selectedFacility?.postal}`}
          </div>
        )}
        {clientPortalStore?.selectedFacility?.address_line_2 && (
          <div className="food-ordering-course-secondary-information">
            {clientPortalStore?.selectedFacility?.address_line_2}
          </div>
        )}
      </div>
    </div>
  );

  const cartOverviewFacilityElement = (
    <div className="food-ordering-cart-overview-facility-container">
      {/* {clientPortalStore?.client?.facilities?.length > 1 && clientPortalStore?.selectedFacility?.logo_source && (
        <div>
          <img className="food-ordering-home-course-logo" src={clientPortalStore?.selectedFacility?.logo_source} />
        </div>
      )} */}
      <div>
        <div className="food-ordering-home-course-name">{clientPortalStore?.selectedFacility?.long_name}</div>
        {clientPortalStore?.selectedFacility && (
          <div className="food-ordering-course-secondary-information">
            {`${clientPortalStore?.selectedFacility?.address_line_1}, ${clientPortalStore?.selectedFacility?.city}, ${clientPortalStore?.selectedFacility?.province_name}, ${clientPortalStore?.selectedFacility?.postal}`}
          </div>
        )}
        {clientPortalStore?.selectedFacility?.address_line_2 && (
          <div className="food-ordering-course-secondary-information">
            {clientPortalStore?.selectedFacility?.address_line_2}
          </div>
        )}
      </div>
    </div>
  );

  function handleFacilityChange(id: number) {
    const foundFacility = clientPortalStore?.client?.facilities?.find(facility => facility?.id === id);
    if (foundFacility) {
      ReactDOM.unstable_batchedUpdates(() => {
        cartActions.cartClear({
          tokenName: getFoodOrderingCartTokenName(clientPortalStore?.selectedFacility?.short_name),
        });
        dispatch(clientPortalUpdate({ selectedFacility: foundFacility }));
        setFilterState(prevState => ({ ...prevState, offset: 0 }));
      });
    }
  }

  function handleFacilitySearch(query: string) {
    setFilterState(prevState => ({ ...prevState, facilitySearchQuery: query }));
  }

  function sendToPage(address: string, openNewTab = false) {
    if (window.location.search.includes(address)) {
      return;
    } else if (openNewTab) {
      window.open(address);
      return;
    }
    history.push(address);
  }

  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { id, value } = e.target;

    ReactDOM.unstable_batchedUpdates(() => {
      setFilterState(prevState => ({ ...prevState, [id]: value }));
    });
  }

  function handleShowSearch() {
    // window.scrollTo(0, 0);
    const ref = searchRef.current;
    ref?.scrollIntoView({ block: "start", behavior: "smooth" });
    setFilterState(prevState => ({ ...prevState, showSearch: true }));
  }

  function addToBag(product: any, variant_id: number, variant?: INewIVariant, quantity?: number) {
    let facilityCollect: any;

    product.collect?.map((collect: any) => {
      if (Number(collect.facility_id) === Number(clientPortalStore?.selectedFacility?.id)) {
        facilityCollect = collect;
      }
    });

    if (variant) {
      if (facilityCollect?.has_modifiers) {
        void openModifierGroups(product as IProduct);
        setModifierState(prevState => ({ ...prevState, modifiedProduct: product, modifiedVariant: variant }));
        //   updateRegisterState({ selectedProduct: product, selectedVariant: variants[0] });

        return;
      }
    }

    setUpdatingQuantity(variant_id);
    uiActions.enqueue();

    try {
      const postCartPromise: Promise<ICart> = cartStore.isLoaded
        ? Promise.resolve(cartStore.cart)
        : (cartActions.postCart(
            {
              tokenName: getFoodOrderingCartTokenName(clientPortalStore?.selectedFacility?.short_name),
              facility_id: clientPortalStore?.selectedFacility?.id,
            },
            true,
          ) as unknown as Promise<ICart>);

      postCartPromise
        .then(cart => {
          if (clientPortalStore?.user && cartStore?.cart?.customer === null) {
            const putCartActionPromise: Promise<ICart> = cartActions.putCart(
              {
                cart_token: cartStore.cart.token,
                customer_email: clientPortalStore?.user?.email,
              },
              false,
            ) as unknown as Promise<ICart>;

            putCartActionPromise
              .then(() => {
                uiActions.dequeue();
                // navigateToForms();
              })
              .catch(() => {
                uiActions.dequeue();
                setUpdatingQuantity(null);

                uiActions.showError(t("Error adding customer to cart"));
              });
          }

          const existingLineItem = cartStore.cart?.line_items?.find(lineItem => lineItem.variant_id === product.id);

          if (existingLineItem?.quantity >= MAX_LINE_ITEM_QUANTITY) {
            return Promise.resolve(undefined);
          } else {
            const postLineItemPromise: Promise<ICart> = cartActions.postLineItem(
              cart.token,
              variant_id,
              quantity ? quantity : 1,
              true,
              null,
              null,
              productDetailsState?.note,
            ) as unknown as Promise<ICart>;

            return postLineItemPromise;
          }
        })
        .then(() => {
          uiActions.dequeue();
          setUpdatingQuantity(null);
          setProductDetailsState(prevState => ({
            ...prevState,
            note: "",
            product: null,
            variant: null,
            quantityToAdd: null,
            line_item: null,
            openProductDetails: false,
          }));
        })
        .catch(() => {
          uiActions.dequeue();
          setUpdatingQuantity(null);

          uiActions.showError(t("Error adding item to cart"));
        });
    } catch {
      uiActions.dequeue();
      setUpdatingQuantity(null);
    }
  }

  function handleQuantityChange(lineItem: ICartLineItem) {
    setUpdatingQuantity(lineItem.variant_id);

    const newQuantity = lineItem?.quantity - 1;

    if (isNaN(newQuantity) || lineItem === undefined) {
      return;
    }

    cartActions.putLineItem(lineItem.id, cartStore.cart.token, newQuantity, lineItem.price, true);

    setUpdatingQuantity(null);
  }

  function removeLineItem(lineItem: ICartLineItem) {
    setUpdatingQuantity(lineItem.variant_id);

    if (lineItem === undefined) {
      return;
    }

    void cartActions.deleteLineItem(lineItem.id, cartStore.cart.token, true);

    setEditLineItemState(prevState => ({
      ...prevState,
      openEditLineItem: false,
      product: null,
      variant: null,
      quantity: null,
      allModifierGroups: [],
      selectedModifierVariants: null,
    }));

    setUpdatingQuantity(null);
  }

  async function logoutUser() {
    const logoutRes = await UserLogout(true);

    if (logoutRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error logging out")));
    }

    window.location.reload();
  }

  function openModifierGroups(product: IProduct) {
    // console.log(productId);
    // ReactDOM.unstable_batchedUpdates(() => {
    //   // setVariantSheetOpen(false);
    //   setModifierState(prevState => ({ ...prevState, sheetOpen: true }));
    // });

    // sele

    // const productRes = await GetProducts(
    //   { id: productId, facility_id: clientPortalStore?.selectedFacility?.id, modifier_groups: true },
    //   true,
    // );

    // if (productRes.status !== StatusCode.OK) {
    //   if (cancelToken && cancelToken?.reason) {
    //     dispatch(showError(t("Error getting product modifiers")));

    //     return;
    //   }
    //   return;
    // }

    ReactDOM.unstable_batchedUpdates(() => {
      // setVariantSheetOpen(false);
      setModifierState(prevState => ({ ...prevState, sheetOpen: true }));
    });

    const modifierGroups: Array<IModifierGroup> = product.modifier_groups;

    const selectedModifiers = { ...modifierState?.selectedModifierVariants };

    //Preselect the default modifier groups
    modifierGroups?.forEach((modifier: IModifierGroup) => {
      selectedModifiers[modifier.id.toString()] = [];
      modifier.variants.forEach((variant: IVariant) => {
        if (variant.modifier_group?.default) {
          selectedModifiers[modifier.id.toString()].push(variant);
        }
      });
    });

    setModifierState(prevState => ({
      ...prevState,
      selectedModifierVariants: selectedModifiers,
      allModifierGroups: modifierGroups,
    }));
  }

  function handleCloseModifierGroups() {
    ReactDOM.unstable_batchedUpdates(() => {
      setModifierState(prevState => ({
        ...prevState,
        sheetOpen: false,
        allModifierGroups: [],
        selectedModifierVariants: null,
        quantity: 1,
        modifiedProduct: null,
        modifiedVariant: null,
      }));
    });
  }

  function onModifiersOk() {
    //Modify new line item
    if (modifierState?.modifiedProduct && modifierState?.modifiedVariant) {
      const selectedVariant = { ...modifierState?.modifiedVariant };
      const modifiersToAdd: Array<{ variant_id: number; quantity: number }> = [];
      const modifierVariants: Array<IVariant> = [];

      for (const key in modifierState.selectedModifierVariants) {
        modifierState.selectedModifierVariants[key]?.forEach(variant => {
          modifiersToAdd.push({ variant_id: variant?.id, quantity: 1 });
          modifierVariants.push({ ...variant, quantity: 1 });
        });
      }

      void handleCloseModifierGroups();
      setModifierState(prevState => ({ ...prevState, modifiedProduct: null, modifiedVariant: null }));

      try {
        const postCartPromise: Promise<ICart> = cartStore.isLoaded
          ? Promise.resolve(cartStore.cart)
          : (cartActions.postCart(
              {
                tokenName: getFoodOrderingCartTokenName(clientPortalStore?.selectedFacility?.short_name),
                facility_id: clientPortalStore?.selectedFacility?.id,
              },
              true,
            ) as unknown as Promise<ICart>);

        postCartPromise
          .then(cart => {
            if (clientPortalStore?.user && cartStore?.cart?.customer === null) {
              const putCartActionPromise: Promise<ICart> = cartActions.putCart(
                {
                  cart_token: cartStore.cart.token,
                  customer_email: clientPortalStore?.user?.email,
                },
                true,
              ) as unknown as Promise<ICart>;

              putCartActionPromise
                .then(() => {
                  uiActions.dequeue();
                  // navigateToForms();
                })
                .catch(() => {
                  uiActions.dequeue();
                  uiActions.showError(t("Error adding customer to cart"));
                });
            }

            const existingLineItem = cartStore.cart?.line_items?.find(
              lineItem => lineItem.variant_id === selectedVariant.id,
            );

            if (existingLineItem?.quantity >= MAX_LINE_ITEM_QUANTITY) {
              return Promise.resolve(undefined);
            } else {
              const postLineItemPromise: Promise<ICart> = cartActions.postLineItem(
                cart?.token,
                selectedVariant.id,
                modifierState?.quantity,
                true,
                null,
                null,
                modifierState?.productNote,
                modifiersToAdd,
              ) as unknown as Promise<ICart>;

              return postLineItemPromise;
            }
          })
          .then(() => {
            uiActions.dequeue();

            setModifierState(prevState => ({
              ...prevState,
              productNote: "",
              modifiedProduct: null,
              modifiedVariant: null,
              sheetOpen: false,
            }));

            //   navigateToShoppingBag();
          })
          .catch(() => {
            uiActions.dequeue();
            uiActions.showError(t("Error adding item to cart"));
            setModifierState(prevState => ({
              ...prevState,
              modifiedProduct: null,
              modifiedVariant: null,
              quantity: 1,
              sheetOpen: false,
            }));
          });
      } catch {
        uiActions.dequeue();
      }
    }
  }

  function addModifierVariant(modifierGroup: IModifierGroup, variant: IVariant) {
    const selectedModifiers = { ...modifierState?.selectedModifierVariants };
    const groupKey = modifierGroup.id.toString();
    const selectedGroup = selectedModifiers[groupKey] || [];

    if (modifierGroup.multi_select) {
      const alreadySelected = selectedGroup.some(v => v.id === variant.id);

      if (alreadySelected) {
        // If required and only one is selected, do not allow removal
        if (modifierGroup.required && selectedGroup.length === 1) {
          return;
        }

        // Remove the variant
        selectedModifiers[groupKey] = selectedGroup.filter(v => v.id !== variant.id);
      } else {
        // Add the variant
        selectedModifiers[groupKey] = [...selectedGroup, variant];
      }
    } else {
      // Single select - toggle off if already selected, unless required
      const alreadySelected = selectedGroup.length && selectedGroup[0].id === variant.id;

      if (alreadySelected) {
        if (!modifierGroup.required) {
          selectedModifiers[groupKey] = [];
        }
      } else {
        selectedModifiers[groupKey] = [variant];
      }
    }

    setModifierState(prevState => ({
      ...prevState,
      selectedModifierVariants: selectedModifiers,
    }));
  }

  // function addModifierVariant(modifierGroup: IModifierGroup, variant: IVariant, selected: boolean) {
  //   console.log(modifierGroup);
  //   console.log(variant);
  //   const selectedModifiers = { ...modifierState?.selectedModifierVariants };
  //   if (modifierGroup.multi_select) {
  //     if (selected && selectedModifiers[modifierGroup.id.toString()]?.length >= 1) {
  //       if (modifierGroup.required && selectedModifiers[modifierGroup.id.toString()].length === 1) {
  //         return;
  //       }
  //       const selectedGroup = selectedModifiers[modifierGroup.id.toString()];
  //       selectedModifiers[modifierGroup.id.toString()] = selectedGroup.filter(filtered => filtered.id !== variant.id);
  //     } else {
  //       selectedModifiers[modifierGroup.id.toString()] = [...selectedModifiers[modifierGroup.id.toString()], variant];
  //     }
  //   } else {
  //     selectedModifiers[modifierGroup.id.toString()] = [variant];
  //   }

  //   console.log(selectedModifiers);
  //   setModifierState(prevState => ({ ...prevState, selectedModifierVariants: selectedModifiers }));
  // }

  function updateModifierVariant(modifierGroup: IModifierGroup, variant: IVariant, selected: boolean) {
    const selectedModifiers = { ...editLineItemState?.selectedModifierVariants };
    if (modifierGroup.multi_select) {
      if (selected && selectedModifiers[modifierGroup.id.toString()]?.length >= 1) {
        if (modifierGroup.required && selectedModifiers[modifierGroup.id.toString()].length === 1) {
          return;
        }
        const selectedGroup = selectedModifiers[modifierGroup.id.toString()];
        selectedModifiers[modifierGroup.id.toString()] = selectedGroup.filter(filtered => filtered.id !== variant.id);
      } else {
        selectedModifiers[modifierGroup.id.toString()] = [...selectedModifiers[modifierGroup.id.toString()], variant];
      }
    } else {
      selectedModifiers[modifierGroup.id.toString()] = [variant];
    }

    setEditLineItemState(prevState => ({ ...prevState, selectedModifierVariants: selectedModifiers }));
  }

  function handleSendToCart() {
    try {
      const putCartActionPromise: Promise<ICart> = cartActions.putCart(
        {
          cart_token: cartStore.cart.token,
          notes: filterState?.cartNote,
          customer_email: clientPortalStore?.user?.email,
        },
        true,
      ) as unknown as Promise<ICart>;

      putCartActionPromise
        .then(() => {
          uiActions.dequeue();
          // navigateToForms();
        })
        .catch(() => {
          uiActions.dequeue();
          uiActions.showError(t("Error adding notes to cart"));
        });
    } catch {
      uiActions.dequeue();
    }

    void sendToPage(`/portal/${clientShortName}/food-ordering/cart`);
  }

  function handleClearCart() {
    cartActions.cartClear({ tokenName: getFoodOrderingCartTokenName(clientPortalStore?.selectedFacility?.short_name) });
    setFilterState(prevState => ({ ...prevState, clearCart: false, showCartOption: false, viewCart: false }));
  }

  function handleCloseModifiers() {
    setModifierState(prevState => ({
      ...prevState,
      sheetOpen: false,
      productNote: "",
      modifiedProduct: null,
      modifiedVariant: null,
      selectedModifierVariants: null,
      quantity: 1,
      allModifierGroups: [],
    }));
  }

  function handlePickupTypeChange(type: string) {
    window.sessionStorage.setItem("pickupType", type);
    setFilterState(prevState => ({ ...prevState, pickup_type: type }));
  }

  function handleShowProductDetailsModal(product: any, variant: INewIVariant, line_item: ICartLineItem) {
    console.log(product);
    console.log(variant);
    console.log(line_item);

    let facilityCollect: any;

    // let quantity = 0;

    // cartStore?.cart?.line_items?.map((item: any) => {
    //   if (item.variant_id === variant.id) {
    //     quantity = item.quantity;
    //   }
    // });

    product.collect?.map((collect: any) => {
      if (Number(collect.facility_id) === Number(clientPortalStore?.selectedFacility?.id)) {
        facilityCollect = collect;
      }
    });

    if (variant) {
      if (facilityCollect?.has_modifiers) {
        void openModifierGroups(product as IProduct);
        setModifierState(prevState => ({ ...prevState, modifiedProduct: product, modifiedVariant: variant }));
        //   updateRegisterState({ selectedProduct: product, selectedVariant: variants[0] });

        return;
      } else {
        setProductDetailsState(prevState => ({
          ...prevState,
          product: product,
          variant: variant,
          line_item: line_item,
          openProductDetails: true,
          // productToAddQuantity: quantity,
          quantityToAdd: 1,
        }));
      }
    }
  }

  async function updateModifierItem(product: any, line_item: ICartLineItem, variant: INewIVariant) {
    // if (product.id.toString() in modifierGroups) {
    //   console.log(modifierGroups);
    // }

    const modifierVariants: any = [];
    const selectedModifierVariants: any = [];
    let modifierGroupId = 0;

    const hasModifiers =
      modifierGroups && product.id.toString() in modifierGroups && modifierGroups[product.id.toString()].length > 0;

    if (hasModifiers) {
      if (modifierGroups && product.id.toString() in modifierGroups) {
        modifierGroups[product.id.toString()].forEach(modifier => {
          modifierVariants.push(modifier);
        });
      }
      // modifierGroups &&
      //   product.id.toString() in modifierGroups &&
      //   modifierGroups[product.id.toString()].map(modifier => {
      //     modifierVariants.push(modifier);
      //   });

      const productRes = await GetProducts(
        { id: line_item.product_id, facility_id: clientPortalStore?.selectedFacility?.id, modifier_groups: true },
        true,
      );

      if (productRes.status !== StatusCode.OK) {
        dispatch(showError(t("Error getting product modifiers")));
        return;
      }

      const newModifierGroups: Array<IModifierGroup> = productRes?.data[0]?.modifier_groups;

      newModifierGroups?.forEach((modifier: IModifierGroup) => {
        modifier.variants.forEach((variant: IVariant) => {
          modifierVariants?.forEach((mVariant: ICartLineItem) => {
            if (variant.id === mVariant.variant_id) {
              selectedModifierVariants.push(variant);
              modifierGroupId = modifier.id;
            }
          });
        });
      });

      const currentModifiedVariants: any = [];
      currentModifiedVariants[modifierGroupId] = selectedModifierVariants;

      const currentModifiersToAdd: Array<{ variant_id: number; quantity: number }> = [];
      const currentModifierVariants: Array<IVariant> = [];

      for (const key in currentModifiedVariants) {
        currentModifiedVariants[key]?.forEach((variant: IVariant) => {
          currentModifiersToAdd.push({ variant_id: variant?.id, quantity: 1 });
          currentModifierVariants.push({ ...variant, quantity: 1 });
        });
      }

      try {
        const postCartPromise: Promise<ICart> = cartStore.isLoaded
          ? Promise.resolve(cartStore.cart)
          : (cartActions.postCart(
              {
                tokenName: getFoodOrderingCartTokenName(clientPortalStore?.selectedFacility?.short_name),
                facility_id: clientPortalStore?.selectedFacility?.id,
              },
              true,
            ) as unknown as Promise<ICart>);

        postCartPromise
          .then(cart => {
            if (clientPortalStore?.user && cartStore?.cart?.customer === null) {
              const putCartActionPromise: Promise<ICart> = cartActions.putCart(
                {
                  cart_token: cartStore.cart.token,
                  customer_email: clientPortalStore?.user?.email,
                },
                true,
              ) as unknown as Promise<ICart>;

              putCartActionPromise
                .then(() => {
                  uiActions.dequeue();
                  // navigateToForms();
                })
                .catch(() => {
                  uiActions.dequeue();
                  uiActions.showError(t("Error adding customer to cart"));
                });
            }

            const existingLineItem = cartStore.cart?.line_items?.find(lineItem => lineItem.variant_id === variant.id);

            if (existingLineItem?.quantity >= MAX_LINE_ITEM_QUANTITY) {
              return Promise.resolve(undefined);
            } else {
              const postLineItemPromise: Promise<ICart> = cartActions.postLineItem(
                cart?.token,
                variant.id,
                modifierState?.quantity,
                true,
                null,
                null,
                "",
                currentModifiersToAdd,
              ) as unknown as Promise<ICart>;

              return postLineItemPromise;
            }
          })
          .then(() => {
            uiActions.dequeue();
            //   navigateToShoppingBag();
          })
          .catch(() => {
            uiActions.dequeue();
            uiActions.showError(t("Error adding item to cart"));
          });
      } catch {
        uiActions.dequeue();
      }
    }
  }

  async function handleShowEditLineItem(product: any, line_item: ICartLineItem, variant: INewIVariant) {
    const modifierVariants: any = [];
    const selectedModifierVariants: any = [];
    let modifierGroupId = 0;

    const hasModifiers =
      modifierGroups && product.id.toString() in modifierGroups && modifierGroups[product.id.toString()].length > 0;

    if (hasModifiers) {
      if (modifierGroups && product.id.toString() in modifierGroups) {
        modifierGroups[product.id.toString()].forEach(modifier => {
          modifierVariants.push(modifier);
        });
      }
      // modifierGroups &&
      //   product.id.toString() in modifierGroups &&
      //   modifierGroups[product.id.toString()].map(modifier => {
      //     modifierVariants.push(modifier);
      //   });

      const productRes = await GetProducts(
        { id: line_item.product_id, facility_id: clientPortalStore?.selectedFacility?.id, modifier_groups: true },
        true,
      );

      if (productRes.status !== StatusCode.OK) {
        dispatch(showError(t("Error getting product modifiers")));
        return;
      }

      const newModifierGroups: Array<IModifierGroup> = productRes?.data[0]?.modifier_groups;

      newModifierGroups?.forEach((modifier: IModifierGroup) => {
        modifier.variants.forEach((variant: IVariant) => {
          modifierVariants?.forEach((mVariant: ICartLineItem) => {
            if (variant.id === mVariant.variant_id) {
              selectedModifierVariants.push(variant);
              modifierGroupId = modifier.id;
            }
          });
        });
      });

      const currentModifiedVariants: any = [];
      currentModifiedVariants[modifierGroupId] = selectedModifierVariants;

      setEditLineItemState(prevState => ({
        ...prevState,
        product: product,
        line_item: product,
        variant: variant,
        quantity: product.quantity,
        openEditLineItem: true,
        selectedModifierVariants: currentModifiedVariants,
        allModifierGroups: newModifierGroups,
      }));
      // setFilterState(prevState => ({...prevState, viewCart: false}));
    }

    setEditLineItemState(prevState => ({
      ...prevState,
      product: product,
      variant: variant,
      quantity: product.quantity,
      openEditLineItem: true,
      line_item: product,
    }));
  }

  function handleUpdateLineItem() {
    const modifiersToAdd: Array<{ variant_id: number; quantity: number }> = [];
    const modifierVariants: Array<IVariant> = [];

    for (const key in editLineItemState.selectedModifierVariants) {
      editLineItemState.selectedModifierVariants[key]?.forEach(variant => {
        modifiersToAdd.push({ variant_id: variant?.id, quantity: 1 });
        modifierVariants.push({ ...variant, quantity: 1 });
      });
    }

    cartActions.putLineItem(
      editLineItemState?.line_item.id,
      cartStore.cart.token,
      editLineItemState?.quantity,
      editLineItemState?.line_item.price,
      true,
      modifiersToAdd ? modifiersToAdd : null,
    );

    setEditLineItemState(prevState => ({
      ...prevState,
      openEditLineItem: false,
      product: null,
      variant: null,
      quantity: null,
      allModifierGroups: [],
      selectedModifierVariants: null,
    }));
  }

  const clickOutsideRef = useOnclickOutside(() => {
    setFilterState(prevState => ({ ...prevState, showCartOption: false }));
  });

  function getVariantPrice(variant: IVariant): number {
    if (!variant) {
      return 0;
    }
    let price = variant.price;
    if (variant.inventory_item) {
      const level = variant.inventory_item.inventory_levels?.find(
        level => level.facility_id === clientPortalStore?.selectedFacility?.id,
      );
      if (level && level.price_override) {
        price = Number(level.price_override);
      }
    }

    return price;
  }

  function isOpeningSoon(operatingHour: IOperatingHours): boolean {
    const now = new Date();
    const todayNum = now.getDay() === 0 ? 7 : now.getDay(); // Sunday=0 → 7

    // Only check if this operating hour is for today and not closed
    if (operatingHour.day_of_week_number !== todayNum || operatingHour.closed) {
      return false;
    }

    if (!operatingHour.open_time) {
      return false;
    }

    // Parse today's date with the given opening time
    const [hours, minutes] = operatingHour.open_time.split(":").map(Number);
    const openingDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);

    // Half an hour before opening
    const halfHourBefore = new Date(openingDate.getTime() - 30 * 60 * 1000);

    // Check if now is within 30 minutes before opening
    return now >= halfHourBefore && now < openingDate;
  }

  return (
    <Fragment>
      {foodOrderingClosedState.closed && !filterState?.view_menu ? (
        <div className="food-ordering-closed">
          {windowSize.width > MOBILE_WIDTH ? (
            <div>
              <ClientPortalNavigation showNavOptions />

              <div className="food-ordering-menu-facility-container">
                {clientPortalStore?.client?.facilities?.length > 1 ? (
                  <CustomDropdown
                    parentElement={selectedFacilityElement}
                    onChange={handleFacilityChange}
                    defaultValue={clientPortalStore?.selectedFacility?.id}
                    onSearch={handleFacilitySearch}
                    searchPlacerHolder="Search courses..."
                  >
                    {facilities ? (
                      facilities?.map((facility, index) => {
                        return (
                          <CustomDropdownOption value={facility.id} key={index}>
                            <div className="food-ordering-facility-option-container">
                              <img
                                className="food-ordering-facility-option-facility-logo"
                                src={facility?.logo_source}
                              />
                              <p className="food-ordering-facility-option-facility-name">{facility?.long_name}</p>
                              {windowSize.width > MOBILE_WIDTH ? (
                                <p className="food-ordering-facility-option-facility-address">{facility?.city}</p>
                              ) : null}
                              {facility?.favourite && (
                                <FontAwesomeIcon
                                  size="1x"
                                  fixedWidth
                                  className="food-ordering-facility-option-favourite"
                                  icon={faStar}
                                />
                              )}
                            </div>
                          </CustomDropdownOption>
                        );
                      })
                    ) : (
                      <div className="facility-spinner">
                        <Spin />
                      </div>
                    )}
                  </CustomDropdown>
                ) : (
                  selectedFacilityElement
                )}
              </div>
            </div>
          ) : null}

          <div className="food-ordering-closed-container">
            <div>
              {windowSize.width >= MOBILE_WIDTH && (
                <div className="food-ordering-closed-container_icon_container">
                  <FontAwesomeIcon
                    size="1x"
                    fixedWidth
                    className="food-ordering-closed-container_icon"
                    icon={faUtensilsSlash}
                  />
                </div>
              )}

              <p className="food-ordering-closed-container_title">{t("Food ordering closed")}</p>
              <p className="food-ordering-closed-container_subtitle">
                {foodOrderingClosedState.tomorrow.closed
                  ? `We’ll be back at ${convertTime(foodOrderingClosedState.nextOpenDay?.open_time)} ${
                      foodOrderingClosedState.nextOpenDay?.day_of_week
                    }.`
                  : foodOrderingClosedState.tomorrow?.open_time
                  ? `We’ll be back at ${convertTime(foodOrderingClosedState.tomorrow?.open_time)} tomorrow.`
                  : "We’ll be back tomorrow."}
              </p>
            </div>

            <div>
              <div className="flex justify-center w-full">
                <Button
                  type="primary"
                  onClick={() => setFilterState(prevState => ({ ...prevState, show_hours: true }))}
                  className="food-ordering-closed-container_button"
                >
                  {t("See hours")}
                </Button>
              </div>
              <div className="food-ordering-closed-container_button_container">
                {windowSize.width <= MOBILE_WIDTH && (
                  <Button
                    type="secondary"
                    className="food-ordering-closed-container_secondary_button"
                    onClick={() => window.history.back()}
                  >
                    {t("Go back")}
                  </Button>
                )}

                <Button
                  type="secondary"
                  onClick={() => setFilterState(prevState => ({ ...prevState, view_menu: true }))}
                  className="food-ordering-closed-container_secondary_button"
                >
                  {t("View menu")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="client-portal-food-ordering" ref={searchRef}>
          {windowSize.width <= MOBILE_WIDTH && (
            <div className="food-ordering-title-container">
              <p className="food-ordering-title">{t("Food Ordering")}</p>{" "}
            </div>
          )}

          <ClientPortalNavigation showNavOptions />

          <div className="food-ordering-menu-facility-container">
            {clientPortalStore?.client?.facilities?.length > 1 ? (
              <CustomDropdown
                parentElement={selectedFacilityElement}
                onChange={handleFacilityChange}
                defaultValue={clientPortalStore?.selectedFacility?.id}
                onSearch={handleFacilitySearch}
                searchPlacerHolder="Search courses..."
              >
                {facilities ? (
                  facilities?.map((facility, index) => {
                    return (
                      <CustomDropdownOption value={facility.id} key={index}>
                        <div className="food-ordering-facility-option-container">
                          <img className="food-ordering-facility-option-facility-logo" src={facility?.logo_source} />
                          <p className="food-ordering-facility-option-facility-name">{facility?.long_name}</p>
                          {windowSize.width > MOBILE_WIDTH ? (
                            <p className="food-ordering-facility-option-facility-address">{facility?.city}</p>
                          ) : null}
                          {facility?.favourite && (
                            <FontAwesomeIcon
                              size="1x"
                              fixedWidth
                              className="food-ordering-facility-option-favourite"
                              icon={faStar}
                            />
                          )}
                        </div>
                      </CustomDropdownOption>
                    );
                  })
                ) : (
                  <div className="facility-spinner">
                    <Spin />
                  </div>
                )}
              </CustomDropdown>
            ) : (
              selectedFacilityElement
            )}
          </div>

          <div className="food-ordering-sticky-header-container">
            {!filterState.showSearch && (
              <div className="food-ordering-pickup-cart-container">
                {!filterState?.allow_off_course_orders ? (
                  <div className="food-ordering-pickup-dinein-toggle-container">
                    <div className={classNames("food-ordering-dinein-pickup-tab_selected", {})}>{t("Pickup")}</div>{" "}
                  </div>
                ) : (
                  <>
                    {windowSize.width <= MOBILE_WIDTH ? (
                      <div className="food-ordering-pickup-dinein-toggle-container">
                        <div
                          onClick={() => handlePickupTypeChange("dine_in")}
                          className={classNames("food-ordering-dinein-pickup-tab", {
                            "food-ordering-dinein-pickup-tab_selected": filterState.pickup_type === "dine_in",
                          })}
                        >
                          {t("Dine in")}
                        </div>
                        <div
                          onClick={() => handlePickupTypeChange("pickup")}
                          className={classNames("food-ordering-dinein-pickup-tab", {
                            "food-ordering-dinein-pickup-tab_selected": filterState.pickup_type === "pickup",
                          })}
                        >
                          {t("Pickup")}
                        </div>
                        <div
                          onClick={() => handlePickupTypeChange("delivery")}
                          className={classNames("food-ordering-dinein-pickup-tab", {
                            "food-ordering-dinein-pickup-tab_selected": filterState.pickup_type === "delivery",
                          })}
                        >
                          {t("Delivery")}
                        </div>
                      </div>
                    ) : (
                      <div className="food-ordering-pickup-cart-container_title">{t("Food Ordering")}</div>
                    )}
                  </>
                )}

                <div>
                  {windowSize.width <= MOBILE_WIDTH ? (
                    <div className="flex gap-5 items-center">
                      <FontAwesomeIcon
                        size="1x"
                        fixedWidth
                        className="food-ordering-shopping-cart-icon"
                        icon={["far", "magnifying-glass"]}
                        onClick={handleShowSearch}
                      />
                    </div>
                  ) : (
                    <div className="flex gap-5">
                      <Input
                        onChange={handleInputChange}
                        value={filterState?.searchQuery}
                        id="searchQuery"
                        labelHidden
                        onSearchClear={() => setFilterState(prevState => ({ ...prevState, searchQuery: "" }))}
                        placeholder={t("Search")}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            {foodOrderingClosedState?.closed ? (
              <div className="food-ordering-closed-view-menu-button-container">
                <div className="food-ordering-closed-view-menu-button-container_text_container">
                  <p>
                    <FontAwesomeIcon
                      size="1x"
                      fixedWidth
                      className="food-ordering-closed-view-menu-button-container_text_icon"
                      icon={faExclamationCircle}
                    />
                  </p>
                  <p className="food-ordering-closed-view-menu-button-container_text">
                    {t("Food ordering is currently closed.")}

                    {foodOrderingClosedState.tomorrow.closed
                      ? ` Opens at ${convertTime(foodOrderingClosedState.nextOpenDay?.open_time)} ${
                          foodOrderingClosedState.nextOpenDay?.day_of_week
                        }.`
                      : foodOrderingClosedState.tomorrow?.open_time
                      ? ` Opens at ${convertTime(foodOrderingClosedState.tomorrow?.open_time)} tomorrow.`
                      : " Opens tomorrow."}
                  </p>
                </div>

                <div className="flex items-center ml-4">
                  <Button
                    type="primary"
                    onClick={() => setFilterState(prevState => ({ ...prevState, view_menu: false }))}
                    className=""
                  >
                    <FontAwesomeIcon
                      size="1x"
                      fixedWidth
                      className="food-ordering-closed-view-menu-button-container_button_icon"
                      icon={faArrowLeft}
                    />
                    {t("Go back")}
                  </Button>

                  <Button
                    type="secondary"
                    onClick={() => setFilterState(prevState => ({ ...prevState, show_hours: true }))}
                    className=""
                  >
                    <FontAwesomeIcon
                      size="1x"
                      fixedWidth
                      className="food-ordering-closed-view-menu-button-container_button_icon"
                      icon={faClock}
                    />
                    {t("View hours")}
                  </Button>
                </div>
              </div>
            ) : null}

            {!filterState.showSearch && (
              <div className="food-ordering-tabs-container">
                <div className="food-ordering-tabs-inner-container">
                  <div className="tabs-container">
                    {foodOrderingMenuState?.foodOrderingCategories?.map((category, tabIndex) => {
                      return (
                        <div
                          key={tabIndex}
                          className={classNames("food-ordering-tab", {
                            "food-ordering-tab-selected": tabIndex === tabSelected,
                          })}
                          onClick={() => handleTabChange(tabIndex)}
                        >
                          {category.title}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>

          {filterState.showSearch && windowSize.width <= MOBILE_WIDTH ? (
            <div style={{ paddingTop: "10px", margin: "0 5%" }}>
              <Input
                onChange={handleInputChange}
                value={filterState?.searchQuery}
                id="searchQuery"
                labelHidden
                onSearchClear={() => setFilterState(prevState => ({ ...prevState, searchQuery: "" }))}
                placeholder={t("Search")}
                backArrow
                backArrowOnClick={() =>
                  setFilterState(prevState => ({ ...prevState, showSearch: false, searchQuery: "" }))
                }
              />
            </div>
          ) : null}

          <Fragment>
            <div className="food-ordering-category-container">
              <div className="food-ordering-category-menu-items-container">
                {foodOrderingMenuState?.foodOrderingCategories?.length > 0 && filterState.enabled ? (
                  foodOrderingMenuState?.foodOrderingCategories?.map(
                    (category: IFoodOrderingCategory, categoryIndex: number) => {
                      const displayCategory = category?.products?.some((product: IFoodOrderingProduct) =>
                        product?.variants?.some(
                          variant =>
                            (!variant.cannot_be_sold &&
                              variant?.categoryName.toLowerCase().includes(filterState?.searchQuery.toLowerCase())) ||
                            variant.title.toLowerCase().includes(filterState.searchQuery.toLowerCase()),
                        ),
                      );

                      if (displayCategory) {
                        return category.products.length > 0 ? (
                          <div
                            key={categoryIndex}
                            id={"menu" + String(categoryIndex)}
                            ref={ref => {
                              elementRef.current[categoryIndex] = ref;
                            }}
                            className="food-ordering-menu-items-container"
                          >
                            <h1 className="food-ordering-category-title">{category.title}</h1>

                            <div className="food-ordering-category-products-container">
                              {category?.products?.map((product: IFoodOrderingProduct, productIndex: number) => {
                                return product.variants.length > 0 ? (
                                  <div key={productIndex}>
                                    {product.variants
                                      .filter(
                                        (variant: INewIVariant) =>
                                          (!variant.cannot_be_sold &&
                                            variant.categoryName
                                              .toLowerCase()
                                              .includes(filterState.searchQuery.toLowerCase())) ||
                                          variant.title.toLowerCase().includes(filterState?.searchQuery.toLowerCase()),
                                      )
                                      ?.map((variant: INewIVariant, variantIndex: number) => {
                                        let quantity = 0;
                                        let line_item: ICartLineItem;

                                        cartStore?.cart?.line_items?.map((item: any) => {
                                          if (item.variant_id === variant.id) {
                                            quantity = quantity + Number(item.quantity);
                                            line_item = item;
                                          }
                                        });

                                        return (
                                          <FoodOrderingProductCard
                                            key={variantIndex}
                                            product={product}
                                            variant={variant}
                                            quantity={quantity}
                                            onShowProductDetailsModal={() =>
                                              foodOrderingClosedState?.closed
                                                ? null
                                                : handleShowProductDetailsModal(product, variant, line_item)
                                            }
                                            onHandleQuantityChange={() => handleQuantityChange(line_item)}
                                            onRemoveLineItem={() => removeLineItem(line_item)}
                                            onAddToBag={() => addToBag(product, variant.id, variant)}
                                            line_item={line_item}
                                            showProductImages={true}
                                            facility_id={clientPortalStore?.selectedFacility?.id}
                                            // showProductImages={filterState?.show_product_images}
                                            hideButtons={foodOrderingClosedState?.closed}
                                          />
                                        );
                                      })}
                                  </div>
                                ) : (
                                  <div key={productIndex}></div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <div key={categoryIndex}></div>
                        );
                      }
                    },
                  )
                ) : (
                  <Callout type="error" title={t("No Products")} content={t("There are no products to order")} />
                )}
              </div>
            </div>
          </Fragment>

          {cartStore?.cart?.line_items?.length > 0 && filterState.enabled && (
            <div
              //   onClick={() => sendToPage(`/portal/${clientShortName}/food-ordering/cart-overview`)}
              onClick={() => setFilterState(prevState => ({ ...prevState, viewCart: true }))}
              className="food-ordering-floating-cart-button-container"
            >
              <div className="food-ordering-floating-cart-button">
                {/* <p>View Cart • {cartStore?.cart?.line_items?.length}</p> */}
                <p>
                  {t("View Cart •")} {filterState.cartQuantity}
                </p>{" "}
              </div>
            </div>
          )}

          {/* PRODUCT DETAILS MODAL */}
          <Panel
            open={productDetailsState.openProductDetails && windowSize.width <= MOBILE_WIDTH}
            onClose={() =>
              setProductDetailsState(prevState => ({
                ...prevState,
                openProductDetails: false,
                product: null,
                variant: null,
                line_item: null,
                quantityToAdd: null,
              }))
            }
            animate
            pagePercent={95}
            primaryAction={{
              onClick: () =>
                addToBag(
                  productDetailsState?.product,
                  productDetailsState?.variant?.id,
                  productDetailsState?.variant,
                  productDetailsState?.quantityToAdd,
                ),
              label:
                t("Add") +
                " " +
                String(productDetailsState?.quantityToAdd) +
                " " +
                t("to Cart") +
                " • " +
                displayCurrency(
                  "cad",
                  Number(getVariantPrice(productDetailsState?.variant)) * Number(productDetailsState?.quantityToAdd),
                ),
            }}
            darkerButton
          >
            {productDetailsState?.product?.default_image?.source ? (
              <div className="food-ordering-product-modifier_picture_container">
                <img
                  className="food-ordering-product-modifier_picture"
                  src={productDetailsState?.product?.default_image?.source}
                  alt={t('food-item.png')}
                />
              </div>
            ) : (
              <div className="food-ordering-product-modifier_picture_container food-ordering-product-modifier_no_picture_container">
                <div className="food-ordering-product-modifier-no-picture">
                  <FontAwesomeIcon
                    fixedWidth
                    className="food-ordering-product-modifier-no-picture-icon"
                    icon={faBurgerSoda}
                  />
                </div>
              </div>
            )}

            <div className="food-ordering-product-modifier_product_info">
              <div className="product_title">{productDetailsState?.product?.title}</div>

              <div className="product_price">
                {displayCurrency("cad", getVariantPrice(productDetailsState?.variant))}
              </div>

              <div className="product_description">{productDetailsState?.product?.description}</div>
            </div>

            <div className="flex gap-5">
              <div className="food-ordering-item-modifiers-add-to-cart-button-container">
                <div
                  className={classNames("food-ordering-item-modifiers-add-to-cart-button", {
                    "food-ordering-item-add-to-cart-button-selected": productDetailsState?.quantityToAdd > 0,
                  })}
                >
                  <AddRemoveButton
                    product={productDetailsState?.product}
                    variant={productDetailsState?.variant}
                    quantity={productDetailsState?.quantityToAdd}
                    line_item={productDetailsState?.line_item}
                    variant_id={productDetailsState?.variant?.id}
                    onRemoveLineItem={() => removeLineItem(productDetailsState?.line_item)}
                    onHandleQuantityChange={() =>
                      setProductDetailsState(prevState => ({
                        ...prevState,
                        quantityToAdd: productDetailsState?.quantityToAdd - 1,
                      }))
                    }
                    onAddToBag={() =>
                      setProductDetailsState(prevState => ({
                        ...prevState,
                        quantityToAdd: productDetailsState?.quantityToAdd + 1,
                      }))
                    }
                    disableRemoveLineItem
                  />
                </div>
              </div>
            </div>

            <div className="food-ordering-product-modifier_instructions_container">
              <p className="food-ordering-product-modifier_instructions_container_title">{t("Special Instructions")}</p>{" "}
              <TextField
                //   label={t('Special Instructions')}
                value={productDetailsState?.note}
                onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                  setProductDetailsState(prevState => ({ ...prevState, note: e.target.value }))
                }
                rows={5}
              />
            </div>
          </Panel>

          {/* DESKTOP PRODUCT DETAILS SHEET */}
          <Sheet
            size="medium"
            height="flexible"
            open={productDetailsState.openProductDetails && windowSize.width > MOBILE_WIDTH}
            closable
            title={productDetailsState?.product?.title}
            supportText={productDetailsState?.product?.description}
            cancelText={t("Cancel")}
            darkerButton
            okText={
              t("Add") +
              " " +
              String(productDetailsState?.quantityToAdd) +
              " " +
              t("to Cart") +
              " • " +
              displayCurrency(
                "cad",
                Number(getVariantPrice(productDetailsState?.variant)) * Number(productDetailsState?.quantityToAdd),
              )
            }
            // onOk={handleUpdateLineItem}
            onOk={() =>
              addToBag(
                productDetailsState?.product,
                productDetailsState?.variant?.id,
                productDetailsState?.variant,
                productDetailsState?.quantityToAdd,
              )
            }
            onCancel={() =>
              setProductDetailsState(prevState => ({
                ...prevState,
                openProductDetails: false,
                product: null,
                variant: null,
                line_item: null,
                quantityToAdd: null,
              }))
            }
            backDropCancel={false}
          >
            <div className="flex">
              {productDetailsState?.product?.default_image?.source ? (
                <div className="w-full flex items-center">
                  <div className="food-ordering-product-modifier_picture_container">
                    <img
                      className="food-ordering-product-modifier_picture"
                      src={productDetailsState?.product?.default_image?.source}
                      alt={t('food-item.png')}
                    />
                  </div>
                </div>
              ) : productDetailsState?.product?.product_default_image?.source ? (
                <div className="w-full flex items-center">
                  <div className="food-ordering-product-modifier_picture_container">
                    <img
                      className="food-ordering-product-modifier_picture"
                      src={productDetailsState?.product?.product_default_image?.source}
                      alt={t('food-item.png')}
                    />
                  </div>
                </div>
              ) : (
                <div className="food-ordering-product-modifier_picture_container food-ordering-product-modifier_no_picture_container">
                  <div className="food-ordering-product-modifier-no-picture">
                    <FontAwesomeIcon
                      fixedWidth
                      className="food-ordering-product-modifier-no-picture-icon"
                      icon={faBurgerSoda}
                    />
                  </div>
                </div>
              )}

              <div className="w-full">
                <div className="flex gap-5">
                  <div className="food-ordering-item-modifiers-add-to-cart-button-container">
                    <div
                      className={classNames("food-ordering-item-modifiers-add-to-cart-button", {
                        "food-ordering-item-add-to-cart-button-selected": editLineItemState?.quantity > 0,
                      })}
                    >
                      <AddRemoveButton
                        product={productDetailsState?.product}
                        variant={productDetailsState?.variant}
                        quantity={productDetailsState?.quantityToAdd}
                        line_item={productDetailsState?.line_item}
                        variant_id={productDetailsState?.variant?.id}
                        onRemoveLineItem={() => removeLineItem(productDetailsState?.line_item)}
                        onHandleQuantityChange={() =>
                          setProductDetailsState(prevState => ({
                            ...prevState,
                            quantityToAdd: productDetailsState?.quantityToAdd - 1,
                          }))
                        }
                        onAddToBag={() =>
                          setProductDetailsState(prevState => ({
                            ...prevState,
                            quantityToAdd: productDetailsState?.quantityToAdd + 1,
                          }))
                        }
                        disableRemoveLineItem
                      />
                    </div>
                  </div>
                </div>

                <div className="food-ordering-product-modifier_instructions_container">
                  <p className="food-ordering-product-modifier_instructions_container_title">
                    {t("Special Instructions")}
                  </p>{" "}
                  <TextField
                    //   label={t('Special Instructions')}
                    value={productDetailsState?.note}
                    onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                      setProductDetailsState(prevState => ({ ...prevState, note: e.target.value }))
                    }
                    rows={5}
                  />
                </div>
              </div>
            </div>
          </Sheet>

          {/* MODIFIER PANEL */}
          <div style={{ position: "relative", zIndex: "115" }}>
            <Panel
              open={modifierState.sheetOpen && windowSize.width <= MOBILE_WIDTH}
              onClose={() => setModifierState(prevState => ({ ...prevState, sheetOpen: false }))}
              animate
              pagePercent={95}
              primaryAction={{
                onClick: onModifiersOk,
                label:
                  t("Add") +
                  " " +
                  String(modifierState?.quantity) +
                  " " +
                  t("to Cart") +
                  " • " +
                  displayCurrency("cad", Number(modifierState?.modifiedVariant?.price) * modifierState?.quantity),
                disabled: isOkDisabled,
              }}
              darkerButton
            >
              {modifierState?.modifiedProduct?.default_image?.source ? (
                <div className="food-ordering-product-modifier_picture_container">
                  <img
                    className="food-ordering-product-modifier_picture"
                    src={modifierState?.modifiedProduct?.default_image?.source}
                    alt={t('food-item.png')}
                  />
                </div>
              ) : modifierState?.modifiedProduct?.product_default_image?.source ? (
                <div className="food-ordering-product-modifier_picture_container">
                  <img
                    className="food-ordering-product-modifier_picture"
                    src={modifierState?.modifiedProduct?.product_default_image?.source}
                    alt={t('food-item.png')}
                  />
                </div>
              ) : (
                <div className="food-ordering-product-modifier_picture_container food-ordering-product-modifier_no_picture_container">
                  <div className="food-ordering-product-modifier-no-picture">
                    <FontAwesomeIcon
                      fixedWidth
                      className="food-ordering-product-modifier-no-picture-icon"
                      icon={faBurgerSoda}
                    />
                  </div>
                </div>
              )}

              <div className="food-ordering-product-modifier_product_info">
                <div className="product_title">{modifierState?.modifiedProduct?.title}</div>

                <div className="product_price">
                  {displayCurrency("cad", Number(modifierState?.modifiedProduct?.price))}
                </div>

                <div className="product_description">{modifierState?.modifiedProduct?.description}</div>
              </div>

              <div className="food-ordering-product-modifiers_container">
                <p className="food-ordering-product-modifiers_container_title">{t("Modifiers")}</p>{" "}
                {modifierState?.allModifierGroups?.map((modifierGroup: IFoodOrderingProduct, modifierIndex: number) => {
                  return modifierGroup.variants.length > 0 ? (
                    <div key={modifierIndex}>
                      {modifierGroup?.variants?.map((variant: IVariant, variantIndex: number) => {
                        const found = !!modifierState?.selectedModifierVariants[modifierGroup?.id?.toString()].find(
                          modGroup => modGroup.id === variant.id,
                        );

                        return (
                          <div key={variantIndex} className="product_modifier_container ">
                            <div>
                              <p className="product-modifier-title">
                                {t("Add")} {variant.title}
                              </p>{" "}
                            </div>
                            <div>
                              <Checkbox
                                id="modifier_option"
                                size="medium"
                                checked={found}
                                onChange={() => addModifierVariant(modifierGroup, variant, found)}
                                fullWidth
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div key={modifierIndex}></div>
                  );
                })}
              </div>

              <div className="flex gap-5">
                <div className="food-ordering-item-modifiers-add-to-cart-button-container">
                  <div
                    className={classNames("food-ordering-item-modifiers-add-to-cart-button", {
                      "food-ordering-item-add-to-cart-button-selected": modifierState?.quantity > 0,
                    })}
                  >
                    <AddRemoveButton
                      product={modifierState?.modifiedProduct}
                      variant={modifierState?.modifiedVariant}
                      quantity={modifierState?.quantity}
                      line_item={null}
                      variant_id={productDetailsState?.variant?.id}
                      onRemoveLineItem={null}
                      onHandleQuantityChange={() =>
                        setModifierState(prevState => ({
                          ...prevState,
                          quantity: modifierState?.quantity - 1,
                        }))
                      }
                      onAddToBag={() =>
                        setModifierState(prevState => ({
                          ...prevState,
                          quantity: modifierState?.quantity + 1,
                        }))
                      }
                      disableRemoveLineItem
                    />
                  </div>
                </div>
              </div>

              <div className="food-ordering-product-modifier_instructions_container">
                <p className="food-ordering-product-modifier_instructions_container_title">
                  {t("Special Instructions")}
                </p>{" "}
                <TextField
                  //   label={t('Special Instructions')}
                  value={modifierState?.productNote}
                  onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                    setModifierState(prevState => ({ ...prevState, productNote: e.target.value }))
                  }
                  rows={5}
                />
              </div>
            </Panel>
          </div>

          {/* MODIFIER SHEET  */}
          <Sheet
            size="medium"
            height="flexible"
            open={modifierState.sheetOpen && windowSize.width > MOBILE_WIDTH}
            closable
            title={modifierState?.modifiedProduct?.title}
            supportText={modifierState?.modifiedProduct?.description}
            cancelText={t("Cancel")}
            darkerButton
            okText={
              t("Add") +
              " " +
              String(modifierState?.quantity) +
              " " +
              t("to Cart") +
              " • " +
              displayCurrency("cad", Number(modifierState?.modifiedVariant?.price) * modifierState?.quantity)
            }
            onOk={onModifiersOk}
            onCancel={handleCloseModifiers}
            backDropCancel={false}
            okDisabled={isOkDisabled}
          >
            {modifierState?.allModifierGroups && (
              <div className="flex">
                {modifierState?.modifiedProduct?.default_image?.source ? (
                  <div className="w-full flex items-center">
                    <div className="food-ordering-product-modifier_picture_container">
                      <img
                        className="food-ordering-product-modifier_picture"
                        src={modifierState?.modifiedProduct?.default_image?.source}
                        alt={t('food-item.png')}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="food-ordering-product-modifier_picture_container food-ordering-product-modifier_no_picture_container">
                    <div className="food-ordering-product-modifier-no-picture">
                      <FontAwesomeIcon
                        fixedWidth
                        className="food-ordering-product-modifier-no-picture-icon"
                        icon={faBurgerSoda}
                      />
                    </div>
                  </div>
                )}

                <div className="w-full">
                  <div className="food-ordering-product-modifiers_container">
                    <p className="food-ordering-product-modifiers_container_title">{t("Modifiers")}</p>{" "}
                    {modifierState?.allModifierGroups?.map(
                      (modifierGroup: IFoodOrderingProduct, modifierIndex: number) => {
                        return modifierGroup.variants.length > 0 ? (
                          <div key={modifierIndex}>
                            {modifierGroup?.variants?.map((variant: IVariant, variantIndex: number) => {
                              // return <div>{variant.title}</div>;

                              const found = !!modifierState.selectedModifierVariants[modifierGroup.id.toString()].find(
                                modGroup => modGroup.id === variant.id,
                              );

                              return (
                                <div key={variantIndex} className="product_modifier_container ">
                                  <div>
                                    <p className="product-modifier-title">
                                      {t("Add")} {variant.title}
                                    </p>{" "}
                                  </div>
                                  <div>
                                    <Checkbox
                                      id="modifier_option"
                                      size="medium"
                                      checked={found}
                                      onChange={() => addModifierVariant(modifierGroup, variant, found)}
                                      fullWidth
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div key={modifierIndex}></div>
                        );
                      },
                    )}
                  </div>

                  <div className="flex gap-5">
                    <div className="food-ordering-item-modifiers-add-to-cart-button-container">
                      <div
                        className={classNames("food-ordering-item-modifiers-add-to-cart-button", {
                          "food-ordering-item-add-to-cart-button-selected": modifierState?.quantity > 0,
                        })}
                      >
                        <AddRemoveButton
                          product={modifierState?.modifiedProduct}
                          variant={modifierState?.modifiedVariant}
                          quantity={modifierState?.quantity}
                          line_item={null}
                          variant_id={productDetailsState?.variant?.id}
                          onRemoveLineItem={null}
                          onHandleQuantityChange={() =>
                            setModifierState(prevState => ({
                              ...prevState,
                              quantity: modifierState?.quantity - 1,
                            }))
                          }
                          onAddToBag={() =>
                            setModifierState(prevState => ({
                              ...prevState,
                              quantity: modifierState?.quantity + 1,
                            }))
                          }
                          disableRemoveLineItem
                        />
                      </div>
                    </div>
                  </div>

                  <div className="food-ordering-product-modifier_instructions_container">
                    <p className="food-ordering-product-modifier_instructions_container_title">
                      {t("Special Instructions")}
                    </p>{" "}
                    <TextField
                      //   label={t('Special Instructions')}
                      value={modifierState?.productNote}
                      onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                        setModifierState(prevState => ({ ...prevState, productNote: e.target.value }))
                      }
                      rows={5}
                    />
                  </div>
                </div>
              </div>
            )}
          </Sheet>

          {/* EDIT LINE ITEM PANEL */}
          <div style={{ position: "relative", zIndex: "115" }}>
            <Panel
              open={editLineItemState.openEditLineItem && windowSize.width <= MOBILE_WIDTH}
              onClose={() =>
                setEditLineItemState(prevState => ({
                  ...prevState,
                  openEditLineItem: false,
                  product: null,
                  variant: null,
                  quantity: null,
                  allModifierGroups: [],
                  selectedModifierVariants: null,
                }))
              }
              animate
              pagePercent={95}
              primaryAction={{
                onClick: handleUpdateLineItem,
                label:
                  "Update Cart" + //TODO: Translate
                  " • " +
                  displayCurrency(
                    "cad",
                    Number(getVariantPrice(editLineItemState?.variant)) * editLineItemState?.quantity,
                  ),
              }}
              darkerButton
            >
              {editLineItemState?.product?.default_image?.source ? (
                <div className="food-ordering-product-modifier_picture_container">
                  <img
                    className="food-ordering-product-modifier_picture"
                    src={editLineItemState?.product?.default_image?.source}
                    alt={t('food-item.png')}
                  />
                </div>
              ) : editLineItemState?.product?.product_default_image?.source ? (
                <div className="food-ordering-product-modifier_picture_container">
                  <img
                    className="food-ordering-product-modifier_picture"
                    src={editLineItemState?.product?.product_default_image?.source}
                    alt={t('food-item.png')}
                  />
                </div>
              ) : (
                <div className="food-ordering-product-modifier_picture_container food-ordering-product-modifier_no_picture_container">
                  <div className="food-ordering-product-modifier-no-picture">
                    <FontAwesomeIcon
                      fixedWidth
                      className="food-ordering-product-modifier-no-picture-icon"
                      icon={faBurgerSoda}
                    />
                  </div>
                </div>
              )}

              <div className="food-ordering-product-modifier_product_info">
                <div className="product_title">{editLineItemState?.product?.product_title}</div>

                <div className="product_price">
                  {displayCurrency("cad", Number(editLineItemState?.product?.subtotal_price))}
                </div>

                <div className="product_description">{editLineItemState?.product?.product?.description}</div>
              </div>

              {editLineItemState?.allModifierGroups?.length > 0 && (
                <div className="food-ordering-product-modifiers_container">
                  <p className="food-ordering-product-modifiers_container_title">{t("Modifiers")}</p>{" "}
                  {editLineItemState?.allModifierGroups?.map(
                    (modifierGroup: IFoodOrderingProduct, modifierIndex: number) => {
                      return modifierGroup.variants.length > 0 ? (
                        <div key={modifierIndex}>
                          {modifierGroup?.variants?.map((variant: IVariant, variantIndex: number) => {
                            const found = !!editLineItemState.selectedModifierVariants[
                              modifierGroup?.id?.toString()
                            ].find(modGroup => modGroup.id === variant.id);

                            return (
                              <div key={variantIndex} className="product_modifier_container ">
                                <div>
                                  <p className="product-modifier-title">
                                    {t("Add")} {variant.title}
                                  </p>{" "}
                                </div>
                                <div>
                                  <Checkbox
                                    id="modifier_option"
                                    size="medium"
                                    checked={found}
                                    onChange={() => updateModifierVariant(modifierGroup, variant, found)}
                                    fullWidth
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div key={modifierIndex}></div>
                      );
                    },
                  )}
                </div>
              )}

              <div className="flex gap-5">
                <div className="food-ordering-item-modifiers-add-to-cart-button-container">
                  <div
                    className={classNames("food-ordering-item-modifiers-add-to-cart-button", {
                      "food-ordering-item-add-to-cart-button-selected": editLineItemState?.quantity > 0,
                    })}
                  >
                    {editLineItemState?.quantity === 1 ? (
                      <FontAwesomeIcon
                        size="1x"
                        fixedWidth
                        className={classNames("food-ordering-item-add-to-cart-button-icon", {
                          "food-ordering-item-add-to-cart-button-icon-selected": editLineItemState?.quantity > 0,
                        })}
                        icon={faTrashCan}
                        onClick={() => removeLineItem(editLineItemState?.line_item)}
                      />
                    ) : null}

                    {editLineItemState?.quantity > 1 ? (
                      <FontAwesomeIcon
                        size="1x"
                        fixedWidth
                        className={classNames("food-ordering-item-add-to-cart-button-icon", {
                          "food-ordering-item-add-to-cart-button-icon-selected": editLineItemState?.quantity > 0,
                        })}
                        icon={["far", "minus"]}
                        onClick={() =>
                          setEditLineItemState(prevState => ({
                            ...prevState,
                            quantity: editLineItemState?.quantity - 1,
                          }))
                        }
                      />
                    ) : null}

                    {editLineItemState?.quantity > 0 ? (
                      updatingQuantity ? (
                        <p>
                          <FontAwesomeIcon className="cart-variant-spinner" size="1x" icon={faSpinnerThird} spin fade />
                        </p>
                      ) : (
                        <p>{editLineItemState?.quantity}</p>
                      )
                    ) : null}

                    <FontAwesomeIcon
                      size="1x"
                      fixedWidth
                      className={classNames("food-ordering-item-add-to-cart-button-icon", {
                        "food-ordering-item-add-to-cart-button-icon-selected": editLineItemState?.quantity > 0,
                      })}
                      icon={faPlus}
                      onClick={() =>
                        setEditLineItemState(prevState => ({
                          ...prevState,
                          quantity: editLineItemState?.quantity + 1,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="food-ordering-product-modifier_instructions_container">
                <p className="food-ordering-product-modifier_instructions_container_title">
                  {t("Special Instructions")}
                </p>{" "}
                <TextField
                  //   label={t('Special Instructions')}
                  value={editLineItemState?.note}
                  onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                    setEditLineItemState(prevState => ({ ...prevState, note: e.target.value }))
                  }
                  rows={5}
                />
              </div>
            </Panel>
          </div>

          {/* DESKTOP EDIT LINE ITEM SHEET */}
          <div style={{ position: "relative", zIndex: "115" }}>
            <Sheet
              size="medium"
              height="flexible"
              open={editLineItemState.openEditLineItem && windowSize.width > MOBILE_WIDTH}
              closable
              title={editLineItemState?.product?.product?.title}
              supportText={editLineItemState?.product?.product?.description}
              cancelText={t("Cancel")}
              darkerButton
              okText={
                "Update cart" +
                " • " +
                displayCurrency("cad", getVariantPrice(editLineItemState.variant) * editLineItemState.quantity)
              }
              onOk={handleUpdateLineItem}
              onCancel={() =>
                setEditLineItemState(prevState => ({
                  ...prevState,
                  openEditLineItem: false,
                  product: null,
                  variant: null,
                  quantity: null,
                  allModifierGroups: [],
                  selectedModifierVariants: null,
                }))
              }
              backDropCancel={false}
            >
              {editLineItemState?.allModifierGroups && (
                <div className="flex">
                  {editLineItemState?.product?.default_image?.source ? (
                    <div className="w-full flex items-center">
                      <div className="food-ordering-product-modifier_picture_container">
                        <img
                          className="food-ordering-product-modifier_picture"
                          src={editLineItemState?.product?.default_image?.source}
                          alt={t('food-item.png')}
                        />
                      </div>
                    </div>
                  ) : editLineItemState?.product?.product_default_image?.source ? (
                    <div className="w-full flex items-center">
                      <div className="food-ordering-product-modifier_picture_container">
                        <img
                          className="food-ordering-product-modifier_picture"
                          src={editLineItemState?.product?.product_default_image?.source}
                          alt={t('food-item.png')}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="food-ordering-product-modifier_picture_container food-ordering-product-modifier_no_picture_container">
                      <div className="food-ordering-product-modifier-no-picture">
                        <FontAwesomeIcon
                          fixedWidth
                          className="food-ordering-product-modifier-no-picture-icon"
                          icon={faBurgerSoda}
                        />
                      </div>
                    </div>
                  )}

                  <div className="w-full">
                    {editLineItemState?.allModifierGroups.length > 0 ? (
                      <div className="food-ordering-product-modifiers_container">
                        <p className="food-ordering-product-modifiers_container_title">{t("Modifiers")}</p>{" "}
                        {editLineItemState?.allModifierGroups?.map(
                          (modifierGroup: IFoodOrderingProduct, modifierIndex: number) => {
                            return modifierGroup.variants.length > 0 ? (
                              <div key={modifierIndex}>
                                {modifierGroup?.variants?.map((variant: IVariant, variantIndex: number) => {
                                  const found = !!editLineItemState.selectedModifierVariants[
                                    modifierGroup.id.toString()
                                  ].find(modGroup => modGroup.id === variant.id);

                                  return (
                                    <div key={variantIndex} className="product_modifier_container ">
                                      <div>
                                        <p className="product-modifier-title">
                                          {t("Add")} {variant.title}
                                        </p>{" "}
                                      </div>
                                      <div>
                                        <Checkbox
                                          id="modifier_option"
                                          size="medium"
                                          checked={found}
                                          onChange={() => addModifierVariant(modifierGroup, variant, found)}
                                          fullWidth
                                        />
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <div key={modifierIndex}></div>
                            );
                          },
                        )}
                      </div>
                    ) : null}

                    <div className="flex gap-5">
                      <div className="food-ordering-item-modifiers-add-to-cart-button-container">
                        <div
                          className={classNames("food-ordering-item-modifiers-add-to-cart-button", {
                            "food-ordering-item-add-to-cart-button-selected": editLineItemState?.quantity > 0,
                          })}
                        >
                          {editLineItemState?.quantity === 1 ? (
                            <FontAwesomeIcon
                              size="1x"
                              fixedWidth
                              className={classNames("food-ordering-item-add-to-cart-button-icon", {
                                "food-ordering-item-add-to-cart-button-icon-selected": editLineItemState?.quantity > 0,
                              })}
                              icon={faTrashCan}
                              onClick={() => removeLineItem(editLineItemState?.line_item)}
                            />
                          ) : null}

                          {editLineItemState?.quantity > 1 ? (
                            <FontAwesomeIcon
                              size="1x"
                              fixedWidth
                              className={classNames("food-ordering-item-add-to-cart-button-icon", {
                                "food-ordering-item-add-to-cart-button-icon-selected": editLineItemState?.quantity > 0,
                              })}
                              icon={["far", "minus"]}
                              onClick={() =>
                                setEditLineItemState(prevState => ({
                                  ...prevState,
                                  quantity: editLineItemState?.quantity - 1,
                                }))
                              }
                            />
                          ) : null}

                          {editLineItemState?.quantity > 0 ? (
                            updatingQuantity ? (
                              <p>
                                <FontAwesomeIcon
                                  className="cart-variant-spinner"
                                  size="1x"
                                  icon={faSpinnerThird}
                                  spin
                                  fade
                                />
                              </p>
                            ) : (
                              <p>{editLineItemState?.quantity}</p>
                            )
                          ) : null}

                          <FontAwesomeIcon
                            size="1x"
                            fixedWidth
                            className={classNames("food-ordering-item-add-to-cart-button-icon", {
                              "food-ordering-item-add-to-cart-button-icon-selected": editLineItemState?.quantity > 0,
                            })}
                            icon={faPlus}
                            onClick={() =>
                              setEditLineItemState(prevState => ({
                                ...prevState,
                                quantity: editLineItemState?.quantity + 1,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="food-ordering-product-modifier_instructions_container">
                      <p className="food-ordering-product-modifier_instructions_container_title">
                        {t("Special Instructions")}
                      </p>{" "}
                      <TextField
                        //   label={t('Special Instructions')}
                        value={editLineItemState?.note}
                        onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                          setEditLineItemState(prevState => ({ ...prevState, note: e.target.value }))
                        }
                        rows={5}
                      />
                    </div>
                  </div>
                </div>
              )}
            </Sheet>
          </div>

          {/* DESKTOP VIEW CART */}
          {filterState?.viewCart && windowSize.width >= MOBILE_WIDTH ? (
            <div>
              <div className={classNames("view-cart_container", {})}>
                <div className={classNames("ui-sheet-view-cart", {})}>
                  <div className="flex justify-between items-center">
                    <div className="">
                      <Button
                        type="close"
                        size="large"
                        onClick={() => setFilterState(prevState => ({ ...prevState, viewCart: false }))}
                      >
                        <Icon icon={faTimes} size="medium" />
                      </Button>
                    </div>

                    <div>
                      <Button
                        type="close"
                        size="large"
                        onClick={() => setFilterState(prevState => ({ ...prevState, showCartOption: true }))}
                      >
                        <Icon icon={faEllipsisVertical} size="medium" />
                      </Button>

                      {filterState.showCartOption && (
                        <div
                          className="view-cart-overview-option-container"
                          onClick={() =>
                            setFilterState(prevState => ({ ...prevState, clearCart: true, showCartOption: false }))
                          }
                          ref={clickOutsideRef}
                        >
                          <FontAwesomeIcon
                            size="1x"
                            fixedWidth
                            className="view-cart-overview-option-container_option-title"
                            icon={faTrashCan}
                          />
                          <p className="view-cart-overview-option-container_option-title">{t("Clear cart")}</p>{" "}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={classNames("ui-sheet-content-view-cart", {})}>
                    <div className="food-ordering-cart-overview-panel">
                      <div className="food-ordering-cart-facility-container">{cartOverviewFacilityElement}</div>

                      <div className="food-ordering-cart-overview-panel-items-container">
                        {cartStore?.cart?.line_items?.map((product: any, index: number) => {
                          if (product.parent_id === null) {
                            let quantity = 0;
                            let line_item: ICartLineItem;
                            let variant: INewIVariant = null;

                            cartStore?.cart?.line_items?.map((item: any) => {
                              if (item.variant_id === product.variant_id) {
                                quantity = item.quantity;
                                line_item = item;
                              }
                            });

                            foodOrderingMenuState?.foodOrderingCategories?.map((category: any) => {
                              category?.products?.map((newProduct: any) => {
                                product.categoryName = category.title;

                                if (newProduct?.id === product?.product?.id) {
                                  newProduct?.variants?.map((newVariant: INewIVariant) => {
                                    if (newVariant.id === product.variant_id) {
                                      variant = newVariant;
                                    }
                                  });
                                }
                              });
                            });

                            return (
                              <div key={index} className="food-ordering-cart-overview-panel-item-container">
                                <div
                                  className="food-ordering-cart-overview-panel-item-info-container"
                                  onClick={() => handleShowEditLineItem(product, line_item, variant)}
                                >
                                  <div className="food-ordering-cart-overview-panel-item-quantity">
                                    {product?.quantity}
                                  </div>

                                  <div className="flex flex-col gap-0.5">
                                    <p className="food-ordering-cart-overview-panel-item-title">
                                      {product?.product_title}
                                    </p>
                                    <p className="food-ordering-cart-overview-panel-item-description">
                                      {product?.product?.description}
                                    </p>
                                    <p className="food-ordering-cart-overview-panel-item-price">
                                      {displayCurrency("cad", Number(product?.subtotal_price))}
                                    </p>

                                    {modifierGroups &&
                                      product.id.toString() in modifierGroups &&
                                      modifierGroups[product.id.toString()].map(modifier => {
                                        // const modifierDiscounts = [...discountLines]?.filter(
                                        //   discount => discount?.cart_line_item_id === modifier?.id,
                                        // );
                                        return (
                                          <React.Fragment key={modifier.id}>
                                            <div className="flex items-center gap-2 ml-3">
                                              <p className="food-ordering-cart-overview-panel-item-description">+</p>

                                              <div className="flex gap-2">
                                                <p className="food-ordering-cart-overview-panel-item-description">
                                                  {modifier?.quantity}
                                                </p>
                                                <div className="flex">
                                                  <div className="food-ordering-cart-overview-panel-item-description">
                                                    {modifier?.product_title}
                                                    {modifier?.product_title !== modifier?.variant_title && (
                                                      <p className="food-ordering-cart-overview-panel-item-description">
                                                        {" "}
                                                        {modifier?.variant_title}
                                                      </p>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                              <span className="food-ordering-cart-overview-panel-item-description">
                                                <LocaleCurrency currency="cad" amount={modifier?.subtotal_price} />
                                              </span>
                                            </div>
                                          </React.Fragment>
                                        );
                                      })}
                                  </div>
                                </div>

                                <div className="flex gap-5">
                                  <div className="food-ordering-cart-overview-panel-item-add-to-cart-button-container">
                                    <div
                                      className={classNames("food-ordering-item-add-to-cart-button", {
                                        "food-ordering-item-add-to-cart-button-selected": quantity > 0,
                                      })}
                                    >
                                      {quantity === 1 ? (
                                        <FontAwesomeIcon
                                          size="1x"
                                          fixedWidth
                                          className={classNames("food-ordering-item-add-to-cart-button-icon", {
                                            "food-ordering-item-add-to-cart-button-icon-selected": quantity > 0,
                                          })}
                                          icon={faTrashCan}
                                          onClick={() => removeLineItem(line_item)}
                                        />
                                      ) : null}

                                      {quantity > 1 ? (
                                        <FontAwesomeIcon
                                          size="1x"
                                          fixedWidth
                                          className={classNames("food-ordering-item-add-to-cart-button-icon", {
                                            "food-ordering-item-add-to-cart-button-icon-selected": quantity > 0,
                                          })}
                                          icon={faMinus}
                                          onClick={() => handleQuantityChange(line_item)}
                                        />
                                      ) : null}

                                      {quantity > 0 && <p>{quantity}</p>}

                                      <FontAwesomeIcon
                                        size="1x"
                                        fixedWidth
                                        className={classNames("food-ordering-item-add-to-cart-button-icon", {
                                          "food-ordering-item-add-to-cart-button-icon-selected": quantity > 0,
                                        })}
                                        icon={faPlus}
                                        onClick={
                                          modifierGroups && product.id.toString() in modifierGroups
                                            ? () => updateModifierItem(product, line_item, variant)
                                            : () => addToBag(product, variant?.id, variant)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>

                      <div className="food-ordering-cart-overview-panel-add-items-button-container">
                        <Button
                          type={"secondary"}
                          onClick={() => setFilterState(prevState => ({ ...prevState, viewCart: false }))}
                        >
                          <span className="mr-2">
                            <FontAwesomeIcon size="1x" fixedWidth icon={faPlus} />
                          </span>
                          <span>{t("Add Items")}</span>
                        </Button>
                      </div>

                      <div className="food-ordering-cart-overview-panel-totals-container">
                        <div className="food-ordering-cart-overview-panel-notes-container">
                          <p className="food-ordering-cart-overview-panel-add-notes-button">{t("Add Note")}</p>{" "}
                          <div>
                            <TextField
                              // label={t('Add Note')}
                              value={filterState.cartNote}
                              onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                                setFilterState(prevState => ({ ...prevState, cartNote: e.target.value }))
                              }
                              rows={5}
                            />
                          </div>
                        </div>

                        <div className="food-ordering-cart-overview-panel-subtotal-container">
                          <p className="food-ordering-cart-overview-panel-subtotal-text">{t("Subtotal")}</p>{" "}
                          <p className="food-ordering-cart-overview-panel-subtotal-text">
                            {" "}
                            {displayCurrency("cad", cartStore?.cart?.subtotal_price)}{" "}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div onClick={handleSendToCart} className="food-ordering-cart-overview-panel-cart-button-container">
                      <div className="food-ordering-cart-overview-panel-cart-button">
                        <p className="food-ordering-cart-overview-panel-cart-button_text">{t("Go to checkout")}</p>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={classNames("view-cart-backdrop", {})}
                onClick={() => setFilterState(prevState => ({ ...prevState, viewCart: false }))}
              ></div>
            </div>
          ) : null}

          {/* MOBILE VIEW CART */}
          <Panel
            open={filterState?.viewCart && windowSize.width <= MOBILE_WIDTH}
            onClose={() => setFilterState(prevState => ({ ...prevState, viewCart: false }))}
            animate
            pagePercent={100}
            primaryAction={{
              onClick: handleSendToCart,
              disabled: cartStore?.cart?.line_items?.length < 1,
              label: t("Go to checkout"),
            }}
            darkerButton
          >
            <div className="flex flex-col justify-between h-full">
              <div className="food-ordering-cart-overview-panel">
                <div className="food-ordering-cart-facility-container">{cartOverviewFacilityElement}</div>

                <div className="food-ordering-cart-overview-panel-items-container">
                  {cartStore?.cart?.line_items?.map((product: any, index: number) => {
                    if (product.parent_id === null) {
                      let quantity = 0;
                      let line_item: ICartLineItem;
                      let variant: INewIVariant = null;

                      cartStore?.cart?.line_items?.map((item: any) => {
                        if (item.variant_id === product.variant_id) {
                          quantity = item.quantity;
                          line_item = item;
                        }
                      });

                      foodOrderingMenuState?.foodOrderingCategories?.map((category: any) => {
                        category?.products?.map((newProduct: any) => {
                          product.categoryName = category.title;

                          if (newProduct?.id === product?.product?.id) {
                            newProduct?.variants?.map((newVariant: INewIVariant) => {
                              if (newVariant.id === product.variant_id) {
                                variant = newVariant;
                              }
                            });
                          }
                        });
                      });

                      return (
                        <div key={index} className="food-ordering-cart-overview-panel-item-container">
                          <div
                            className="food-ordering-cart-overview-panel-item-info-container"
                            onClick={() => handleShowEditLineItem(product, line_item, variant)}
                          >
                            <div className="food-ordering-cart-overview-panel-item-quantity">{product?.quantity}</div>

                            <div className="flex flex-col gap-0.5">
                              <p className="food-ordering-cart-overview-panel-item-title">{product?.product_title}</p>
                              <p className="food-ordering-cart-overview-panel-item-description">
                                {product?.product?.description}
                              </p>
                              <p className="food-ordering-cart-overview-panel-item-price">
                                {displayCurrency("cad", Number(product?.subtotal_price))}
                              </p>

                              {modifierGroups &&
                                product.id.toString() in modifierGroups &&
                                modifierGroups[product.id.toString()].map(modifier => {
                                  // const modifierDiscounts = [...discountLines]?.filter(
                                  //   discount => discount?.cart_line_item_id === modifier?.id,
                                  // );
                                  return (
                                    <React.Fragment key={modifier.id}>
                                      <div className="flex items-center gap-2 ml-3">
                                        <p className="food-ordering-cart-overview-panel-item-description">+</p>

                                        <div className="flex gap-2">
                                          <p className="food-ordering-cart-overview-panel-item-description">
                                            {modifier?.quantity}
                                          </p>
                                          <div className="flex">
                                            <div className="food-ordering-cart-overview-panel-item-description">
                                              {modifier?.product_title}
                                              {modifier?.product_title !== modifier?.variant_title && (
                                                <p className="food-ordering-cart-overview-panel-item-description">
                                                  {" "}
                                                  {modifier?.variant_title}
                                                </p>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <span className="food-ordering-cart-overview-panel-item-description">
                                          <LocaleCurrency currency="cad" amount={modifier?.subtotal_price} />
                                        </span>
                                      </div>
                                    </React.Fragment>
                                  );
                                })}
                            </div>
                          </div>

                          <div className="flex gap-5">
                            <div className="food-ordering-cart-overview-panel-item-add-to-cart-button-container">
                              <div
                                className={classNames("food-ordering-item-add-to-cart-button", {
                                  "food-ordering-item-add-to-cart-button-selected": quantity > 0,
                                })}
                              >
                                {quantity === 1 ? (
                                  <FontAwesomeIcon
                                    size="1x"
                                    fixedWidth
                                    className={classNames("food-ordering-item-add-to-cart-button-icon", {
                                      "food-ordering-item-add-to-cart-button-icon-selected": quantity > 0,
                                    })}
                                    icon={faTrashCan}
                                    onClick={() => removeLineItem(line_item)}
                                  />
                                ) : null}

                                {quantity > 1 ? (
                                  <FontAwesomeIcon
                                    size="1x"
                                    fixedWidth
                                    className={classNames("food-ordering-item-add-to-cart-button-icon", {
                                      "food-ordering-item-add-to-cart-button-icon-selected": quantity > 0,
                                    })}
                                    icon={faMinus}
                                    onClick={() => handleQuantityChange(line_item)}
                                  />
                                ) : null}

                                {quantity > 0 && <p>{quantity}</p>}

                                <FontAwesomeIcon
                                  size="1x"
                                  fixedWidth
                                  className={classNames("food-ordering-item-add-to-cart-button-icon", {
                                    "food-ordering-item-add-to-cart-button-icon-selected": quantity > 0,
                                  })}
                                  icon={faPlus}
                                  onClick={
                                    modifierGroups && product.id.toString() in modifierGroups
                                      ? () => updateModifierItem(product, line_item, variant)
                                      : () => addToBag(product, variant?.id, variant)
                                  }
                                />
                              </div>
                            </div>
                            {/* <div className="food-ordering-cart-overview-panel-item-add-to-cart-button-container">


                          <AddRemoveButton
                            product={product}
                            quantity={quantity}
                            line_item={line_item}
                            onRemoveLineItem={() => removeLineItem(line_item)}
                            onHandleQuantityChange={() => handleQuantityChange(line_item)}
                            onAddToBag={() => addToBag(product, product.variant_id)}
                            variant_id={product.variant_id}
                          />
                        </div> */}
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>

                <div className="food-ordering-cart-overview-panel-add-items-button-container">
                  <Button
                    type={"secondary"}
                    onClick={() => setFilterState(prevState => ({ ...prevState, viewCart: false }))}
                  >
                    <span className="mr-2">
                      <FontAwesomeIcon size="1x" fixedWidth icon={["far", "plus"]} />
                    </span>
                    <span>{t("Go to checkout")}</span>
                  </Button>
                </div>
              </div>

              <div className="food-ordering-cart-overview-panel-totals-container">
                <div className="food-ordering-cart-overview-panel-notes-container">
                  <p className="food-ordering-cart-overview-panel-add-notes-button">{t("Add Items")}</p>{" "}
                  <div>
                    <TextField
                      // label={t('Add Note')}
                      value={filterState.cartNote}
                      onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                        setFilterState(prevState => ({ ...prevState, cartNote: e.target.value }))
                      }
                      rows={5}
                    />
                  </div>
                </div>

                <div className="food-ordering-cart-overview-panel-subtotal-container">
                  <p className="food-ordering-cart-overview-panel-subtotal-text">{t("Add Note")}</p>{" "}
                  <p className="food-ordering-cart-overview-panel-subtotal-text">
                    {" "}
                    {displayCurrency("cad", cartStore?.cart?.subtotal_price)}{" "}
                  </p>
                </div>
              </div>
            </div>
          </Panel>

          <Popup
            open={filterState.adminUserLoggedIn}
            type="warning"
            title={t("Subtotal")}
            description={t("Admin Account Detected")}
            onOk={logoutUser}
            okText={t("Looks like you are logged into an admin account. Click logout below.")}
          />

          <Popup
            open={filterState.clearCart}
            type="warning"
            title={t("Logout")}
            description={t("Clearing Cart")}
            onOk={handleClearCart}
            okText={t("Are you sure you want to clear your cart?")}
            closable
            onCancel={() => setFilterState(prevState => ({ ...prevState, clearCart: false }))}
          />
        </div>
      )}

      <div style={{ position: "relative", zIndex: "115" }}>
        <Sheet
          size="small"
          height="flexible"
          open={filterState.show_hours && windowSize.width > MOBILE_WIDTH}
          closable
          title={t("Hours of Operation")}
          supportText={clientPortalStore?.selectedFacility?.long_name}
          okText={t("Close")}
          onOk={() => setFilterState(prevState => ({ ...prevState, show_hours: false }))}
          backDropCancel
          onCancel={() => setFilterState(prevState => ({ ...prevState, show_hours: false }))}
        >
          {foodOrderingClosedState?.operating_hours?.map((hour: IOperatingHours, index: number) => {
            const openingSoon = isOpeningSoon(hour);

            return (
              <div key={index} className="food-ordering-closed-state_hours_container">
                <div
                  className={classNames("food-ordering-closed-state_hours_container_day", {
                    "food-ordering-closed-state_hours_container_today":
                      foodOrderingClosedState?.today?.day_of_week_number === hour?.day_of_week_number,
                  })}
                >
                  {hour.day_of_week}

                  {openingSoon && (
                    <Badge type="warning" size="small">
                      {t("Opening soon")}
                    </Badge>
                  )}
                </div>

                <div>
                  {hour?.closed ? (
                    <p
                      className={classNames("food-ordering-closed-state_hours_container_time", {
                        "food-ordering-closed-state_hours_container_today":
                          foodOrderingClosedState?.today?.day_of_week_number === hour?.day_of_week_number,
                      })}
                    >
                      {t("Closed")}
                    </p>
                  ) : (
                    <p
                      className={classNames("food-ordering-closed-state_hours_container_time", {
                        "food-ordering-closed-state_hours_container_today":
                          foodOrderingClosedState?.today?.day_of_week_number === hour?.day_of_week_number,
                      })}
                    >
                      {convertTime(hour.open_time)} - {convertTime(hour.close_time)}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </Sheet>
      </div>

      <div style={{ position: "relative", zIndex: "115" }}>
        <Panel
          open={filterState?.show_hours && windowSize.width <= MOBILE_WIDTH}
          onClose={() => setFilterState(prevState => ({ ...prevState, show_hours: false }))}
          animate
          pagePercent={85}
          // primaryAction={{
          //   onClick: () => setFilterState(prevState => ({ ...prevState, show_hours: false })),
          //   label: "Notify me when open",
          // }}
          secondaryAction={{
            onClick: () => setFilterState(prevState => ({ ...prevState, show_hours: false })),
            label: t("Close"),
          }}
          title={t("Hours of Operation")}
          subtitle={clientPortalStore?.selectedFacility?.long_name}
        >
          {foodOrderingClosedState?.operating_hours?.map((hour: IOperatingHours, index: number) => {
            const openingSoon = isOpeningSoon(hour);

            return (
              <div key={index} className="food-ordering-closed-state_hours_container">
                <div
                  className={classNames("food-ordering-closed-state_hours_container_day", {
                    "food-ordering-closed-state_hours_container_today":
                      foodOrderingClosedState?.today?.day_of_week_number === hour?.day_of_week_number,
                  })}
                >
                  {hour.day_of_week}

                  {openingSoon && (
                    <Badge type="warning" size="small">
                      {t("Opening soon")}
                    </Badge>
                  )}
                </div>

                <div>
                  {hour?.closed ? (
                    <p
                      className={classNames("food-ordering-closed-state_hours_container_time", {
                        "food-ordering-closed-state_hours_container_today":
                          foodOrderingClosedState?.today?.day_of_week_number === hour?.day_of_week_number,
                      })}
                    >
                      {t("Closed")}
                    </p>
                  ) : (
                    <p
                      className={classNames("food-ordering-closed-state_hours_container_time", {
                        "food-ordering-closed-state_hours_container_today":
                          foodOrderingClosedState?.today?.day_of_week_number === hour?.day_of_week_number,
                      })}
                    >
                      {convertTime(hour.open_time)} - {convertTime(hour.close_time)}
                    </p>
                  )}
                </div>
              </div>
            );
          })}

          <div className="food-ordering-closed-state_hours_footer">
            <p>{t("Note: All times are local")}</p>
          </div>
        </Panel>
      </div>
    </Fragment>
  );
}
